/* 26-pd-promotion-lottery.js
 * PD Promotion Lottery — 抽奖组件 JS
 * 复用 m26-mystery-box.js 中的通用基础设施（M26Lottery / M26Modal / m26-login-guard 等），
 * 本文件只实现 pdlottery 特有逻辑：
 *   - 双视频切换（待机 → 抽奖动画 → 展示结果）
 *   - 获奖记录 + 规则 合并弹框（带 Tab 切换）
 */

/* ── 活动类型（通过 Liquid 注入） ─────────────────────────────────────── */
(function () {
  "use strict";

  let M26ModalLocal = null;
  let M26LotteryLocal = null;
  let m26AuthLocal = null;
  let m26FetchLocal = null;
  let m26I18nLocal = null;
  let m26ToastLocal = null;
  let m26ApiErrorTipLocal = null;
  let m26LoginLocal = null;

  /* 查找当前 section 注入的 activityType，兼容多实例 */
  function resolveActivityType(sectionId) {
    const norm = (sectionId || "").replace(/-/g, "_");
    const k1 = "__PDLOTTERY_ACTIVITY_TYPE_" + norm + "__";
    const k2 = "__PDLOTTERY_ACTIVITY_TYPE_" + norm;
    return window[k1] || window[k2] || window.__MC_ACTIVITY_TYPE__ || "";
  }

  /* ── 复用 m26 基础设施（m26Auth / m26Fetch / M26Modal / m26I18n 等） ── */
  /* 这些工具在 m26-mystery-box.js 中已定义，26-pd-promotion-lottery.js
     通过 defer 保证在 m26-mystery-box.js 之后加载，或与之并列加载。
     若页面只引入本文件，则在此处提供独立回退实现。 */

  function ensureM26Base() {
    /* 若 m26-mystery-box.js 已经加载，直接复用 */
    if (window.__pdlottery_base_ready__) return;
    window.__pdlottery_base_ready__ = true;

    const hasGlobalModal = typeof M26Modal !== "undefined" ? M26Modal : null;
    const hasGlobalLottery =
      typeof M26Lottery !== "undefined" ? M26Lottery : null;
    const hasGlobalFetch = typeof m26Fetch !== "undefined" ? m26Fetch : null;
    const hasGlobalAuth = typeof m26Auth !== "undefined" ? m26Auth : null;
    const hasGlobalI18n = typeof m26I18n !== "undefined" ? m26I18n : null;
    const hasGlobalToast = typeof m26Toast !== "undefined" ? m26Toast : null;
    const hasGlobalErrTip =
      typeof m26ApiErrorTip !== "undefined" ? m26ApiErrorTip : null;
    const hasGlobalLogin = typeof m26Login !== "undefined" ? m26Login : null;

    if (hasGlobalModal && hasGlobalLottery && hasGlobalFetch && hasGlobalAuth) {
      M26ModalLocal = hasGlobalModal;
      M26LotteryLocal = hasGlobalLottery;
      m26FetchLocal = hasGlobalFetch;
      m26AuthLocal = hasGlobalAuth;
      m26I18nLocal = hasGlobalI18n;
      m26ToastLocal = hasGlobalToast;
      m26ApiErrorTipLocal = hasGlobalErrTip;
      m26LoginLocal = hasGlobalLogin;
      return;
    }

    function getCookie(name) {
      const key = `${encodeURIComponent(name)}=`;
      const parts = document.cookie.split(";");
      for (let i = 0; i < parts.length; i++) {
        const p = parts[i].trim();
        if (p.indexOf(key) === 0)
          return decodeURIComponent(p.slice(key.length));
      }
      return null;
    }

    function parseJwt(token) {
      try {
        const payload = token.split(".")[1];
        if (!payload) return null;
        const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
        const pad = "=".repeat((4 - (base64.length % 4)) % 4);
        return JSON.parse(atob(base64 + pad));
      } catch (_) {
        return null;
      }
    }

    m26I18nLocal = {
      _d: null,
      get(ns) {
        if (!this._d) {
          const el = document.getElementById("lottery-i18n");
          try {
            this._d = JSON.parse(el && el.textContent ? el.textContent : "{}");
          } catch (_) {
            this._d = {};
          }
        }
        return this._d[ns] || {};
      },
    };

    m26AuthLocal = { user: null, _cbs: [] };
    m26AuthLocal.onLogin = function (cb) {
      if (m26AuthLocal.user) {
        cb(m26AuthLocal.user);
        return;
      }
      m26AuthLocal._cbs.push(cb);
    };

    const cookieName =
      (window.__MC__CONFIG__ && window.__MC__CONFIG__.cookieName) ||
      "momcozy-token";
    const token = getCookie(cookieName);
    if (token) {
      const payload = parseJwt(token) || {};
      m26AuthLocal.user = {
        type: "cookie",
        token,
        email: payload.email || payload.sub || "",
      };
    }

    document.addEventListener("LUTE:AUTH:LOGIN", (e) => {
      m26AuthLocal.user = e.detail;
      m26AuthLocal._cbs.forEach((fn) => fn(m26AuthLocal.user));
      m26AuthLocal._cbs.length = 0;
    });
    document.addEventListener("LUTE:AUTH:LOGOUT", () => {
      m26AuthLocal.user = null;
    });

    const apiBase =
      (window.__MC__CONFIG__ && window.__MC__CONFIG__.apiUrl) ||
      "https://account.momcozy.com";

    m26FetchLocal = async function (path, opts = {}) {
      const headers = {
        "Content-Type": "application/json",
        ...(window.__MC__CONFIG__ && window.__MC__CONFIG__.headers
          ? window.__MC__CONFIG__.headers
          : {}),
      };
      if (m26AuthLocal.user && m26AuthLocal.user.token)
        headers["Authorization"] = `Bearer ${m26AuthLocal.user.token}`;
      const res = await fetch(`${apiBase}${path}`, { headers, ...opts });
      const data = await res.json().catch(() => ({}));
      if (data && data.code === "10001003") {
        m26AuthLocal.user = null;
        document.dispatchEvent(new CustomEvent("lute:account:logout"));
        throw data;
      }
      if (data && data.code === "200") return data.result || data.data || true;
      throw data;
    };

    function getRedirectUrl() {
      return window.location.href;
    }

    m26LoginLocal = function () {
      const loginDialog = document.querySelector("login-dialog");
      if (loginDialog && typeof loginDialog.open === "function") {
        /* iOS Safari 跳顶修复：MO 监听 body.q-body--prevent-scroll class 移除，
           第三方 dialog 关闭瞬间同步 scrollTo + focus 还原位置。
           open 前不修改任何 body 样式，避免 iOS paint glitch。 */
        const savedScrollY = window.scrollY || 0;
        const savedActiveEl = document.activeElement;

        let restored = false;
        let timeoutId = null;
        const cleanup = () => {
          if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
          }
          observer.disconnect();
        };
        const restore = () => {
          if (restored) return;
          restored = true;
          cleanup();
          if (savedScrollY > 0) window.scrollTo(0, savedScrollY);
          try {
            if (
              savedActiveEl &&
              savedActiveEl !== document.body &&
              savedActiveEl !== document.documentElement &&
              typeof savedActiveEl.focus === "function"
            ) {
              savedActiveEl.focus({ preventScroll: true });
            }
          } catch (_) { /* element 已被移除，静默忽略 */ }
        };
        /* rAF 等 commit 后再 getComputedStyle，避免读到旧样式 */
        const observer = new MutationObserver(() => {
          if (document.body.classList.contains("q-body--prevent-scroll")) return;
          requestAnimationFrame(() => {
            const csHtml = window.getComputedStyle(document.documentElement);
            if (
              !csHtml.overflow.includes("hidden") &&
              !csHtml.overflowY.includes("hidden")
            ) {
              restore();
            }
          });
        });
        observer.observe(document.body, {
          attributes: true,
          attributeFilter: ["class"],
        });
        /* 兜底：dialog 异常长时间挂起时不强制 focus（避免抢正在输入的焦点） */
        timeoutId = setTimeout(cleanup, 60000);

        loginDialog.open(null, {
          activityType: `activity_${window.__MC_ACTIVITY_TYPE__ || ""}`,
          mustAgreeEmail: true,
          redirect: getRedirectUrl(),
        });
      }
    };

    if (!customElements.get("m26-login-guard")) {
      class M26LoginGuard extends HTMLElement {
        connectedCallback() {
          this.addEventListener("click", this, true);
        }
        disconnectedCallback() {
          this.removeEventListener("click", this, true);
        }
        handleEvent(e) {
          if (e.type === "click") {
            pdSyncM26AuthFromCookie();
            const auth = pdGetM26Auth();
            if (!(auth && auth.user)) {
              e.stopPropagation();
              e.preventDefault();
              const app = this.closest("pdlottery-app");
              if (app && typeof app._pdlLogin === "function") {
                app._pdlLogin();
              } else {
                if (m26LoginLocal) m26LoginLocal();
              }
            }
          }
        }
      }
      customElements.define("m26-login-guard", M26LoginGuard);
    }

    class _M26Modal {
      static _openCount = 0;
      static _overlayEl = null;
      static _syncStack() {
        const overlay = _M26Modal._overlayEl;
        if (!overlay) return;
        let topBox = null;
        for (let i = overlay.children.length - 1; i >= 0; i--) {
          const child = overlay.children[i];
          if (
            child &&
            child.classList &&
            child.classList.contains("m26-modal-box") &&
            child.classList.contains("is-open")
          ) {
            topBox = child;
            break;
          }
        }
        overlay.querySelectorAll(".m26-modal-box.is-open").forEach((box) => {
          if (box === topBox) {
            box.classList.remove("m26-modal-box--inactive");
            box.removeAttribute("aria-hidden");
          } else {
            box.classList.add("m26-modal-box--inactive");
            box.setAttribute("aria-hidden", "true");
          }
        });
      }
      static _getOverlay() {
        if (_M26Modal._overlayEl) return _M26Modal._overlayEl;
        const el = document.createElement("div");
        el.className = "m26-modal-overlay";
        el.addEventListener("click", (e) => {
          if (e.target !== el) return;
          for (let i = el.children.length - 1; i >= 0; i--) {
            const inst = el.children[i]._m26;
            if (inst && inst._isOpen) {
              inst.close();
              break;
            }
          }
        });
        document.body.appendChild(el);
        _M26Modal._overlayEl = el;
        return el;
      }
      constructor(className) {
        this._boxEl = null;
        this._bodyEl = null;
        this._triggerEl = null;
        this._closeTimer = null;
        this._isOpen = false;
        this._className = className || "";
        this._handleEvent = this._handleEvent.bind(this);
      }
      setContent(html) {
        if (this._bodyEl) this._bodyEl.innerHTML = html;
        this._bodyHtml = html;
      }
      _syncA11yLabel() {
        if (!this._boxEl) return;
        const titleEl = this._boxEl.querySelector(
          "h1, h2, h3, [data-modal-title]",
        );
        if (titleEl) {
          if (!titleEl.id)
            titleEl.id = "m26dlg_" + Math.random().toString(36).slice(2, 10);
          this._boxEl.setAttribute("aria-labelledby", titleEl.id);
          this._boxEl.removeAttribute("aria-label");
        } else {
          this._boxEl.removeAttribute("aria-labelledby");
          this._boxEl.setAttribute("aria-label", "Dialog");
        }
      }
      _isTopMost() {
        if (!this._boxEl) return true;
        const overlay = _M26Modal._overlayEl;
        if (!overlay) return true;
        for (let i = overlay.children.length - 1; i >= 0; i--) {
          const child = overlay.children[i];
          if (
            child &&
            child.classList &&
            child.classList.contains("m26-modal-box") &&
            child.classList.contains("is-open")
          ) {
            return child === this._boxEl;
          }
        }
        return true;
      }
      show() {
        this._triggerEl = document.activeElement;
        this._ensureBox();
        const box = this._boxEl;
        if (box)
          box.className =
            "m26-modal-box nt" + (this._className ? " " + this._className : "");
        if (this._bodyHtml && this._bodyEl)
          this._bodyEl.innerHTML = this._bodyHtml;
        this._syncA11yLabel();
        const overlay = _M26Modal._getOverlay();
        if (this._boxEl && this._boxEl.parentNode === overlay)
          overlay.appendChild(this._boxEl);
        requestAnimationFrame(() => {
          if (!this._boxEl || !this._bodyEl) return;
          overlay.classList.add("is-open");
          this._boxEl.classList.add("is-open");
          _M26Modal._openCount++;
          _M26Modal._syncStack();
          if (_M26Modal._openCount === 1)
            document.documentElement.classList.add("m26-scroll-lock");
          document.addEventListener("keydown", this._handleEvent);
          this._isOpen = true;
          const first = this._boxEl.querySelector(
            '[data-close], button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
          );
          if (first) first.focus();
        });
      }
      close() {
        if (!this._boxEl || !this._isOpen) return;
        this._isOpen = false;
        this._boxEl.classList.remove("is-open");
        _M26Modal._syncStack();
        document.removeEventListener("keydown", this._handleEvent);
        this._closeTimer = setTimeout(() => this._afterClose(), 350);
        this._boxEl.addEventListener(
          "transitionend",
          (e) => {
            if (e.target === this._boxEl && !this._isOpen) this._afterClose();
          },
          { once: true },
        );
      }
      _afterClose() {
        clearTimeout(this._closeTimer);
        this._closeTimer = null;
        /* close 时把当前 body 内容缓存到 _bodyHtml，后续 show() 用 _bodyHtml 恢复。
           关键：消费者常在 show 之后异步加载数据（如 record list）追加到 _bodyEl，
           此时 _bodyHtml 仍是模板（不含数据）。close 时同步保存最新 innerHTML
           能让 close→show 循环不丢数据。 */
        if (this._bodyEl) this._bodyHtml = this._bodyEl.innerHTML;
        _M26Modal._openCount = Math.max(0, _M26Modal._openCount - 1);
        if (_M26Modal._openCount === 0) {
          document.documentElement.classList.remove("m26-scroll-lock");
          if (_M26Modal._overlayEl)
            _M26Modal._overlayEl.classList.remove("is-open");
        }
        _M26Modal._syncStack();
        // iOS Safari 修复：先还原滚动位置，再安全地把焦点还给 triggerEl
        // 避免 body/html 上的 focus() 触发 iOS 跳顶
        if (typeof window !== "undefined" && this._scrollY != null) {
          window.scrollTo(0, this._scrollY);
        }
        const t = this._triggerEl;
        if (
          t &&
          t !== document.body &&
          t !== document.documentElement &&
          typeof t.focus === "function"
        ) {
          t.focus({ preventScroll: true });
        }
        this._triggerEl = null;
      }
      _handleEvent(e) {
        if (e.type === "keydown") {
          if (!this._isTopMost()) return;
          if (e.key === "Escape") this.close();
          else if (e.key === "Tab") this._trapFocus(e);
        }
      }
      _trapFocus(e) {
        if (!this._boxEl) return;
        const focusable = this._boxEl.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        );
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
      _ensureBox() {
        if (this._boxEl) return;
        const overlay = _M26Modal._getOverlay();
        const box = document.createElement("div");
        box.className = "m26-modal-box nt";
        box.setAttribute("role", "dialog");
        box.setAttribute("aria-modal", "true");
        box.innerHTML = `
          <button type="button" class="m26-modal__close" data-close aria-label="Close">
            <svg class="m26-modal__close-icon" aria-hidden="true">
              <use xlink:href="#lottery-modal-close"></use>
            </svg>
          </button>
          <div class="m26-modal__body"></div>`;
        box._m26 = this;
        box.querySelector("[data-close]").addEventListener("click", () => {
          if (!this._isTopMost()) return;
          this.close();
        });
        overlay.appendChild(box);
        this._boxEl = box;
        this._bodyEl = box.querySelector(".m26-modal__body");
      }
      destroy() {
        document.removeEventListener("keydown", this._handleEvent);
        const pending = this._isOpen || this._closeTimer;
        clearTimeout(this._closeTimer);
        this._closeTimer = null;
        this._isOpen = false;
        if (pending) {
          _M26Modal._openCount = Math.max(0, _M26Modal._openCount - 1);
          if (_M26Modal._openCount === 0) {
            document.documentElement.classList.remove("m26-scroll-lock");
            if (_M26Modal._overlayEl)
              _M26Modal._overlayEl.classList.remove("is-open");
          }
        }
        if (this._boxEl) {
          this._boxEl.remove();
          this._boxEl = null;
          this._bodyEl = null;
        }
        _M26Modal._syncStack();
      }
    }
    M26ModalLocal = _M26Modal;

    if (!customElements.get("m26-share-panel")) {
      class M26SharePanel extends HTMLElement {
        connectedCallback() {
          if (this._init) return;
          this._init = true;
          this._modal = null;
          this.addEventListener("click", this);
        }
        disconnectedCallback() {
          this.removeEventListener("click", this);
          if (this._modal) {
            this._modal.destroy();
            this._modal = null;
          }
        }
        handleEvent(e) {
          if (e.type !== "click") return;
          /* modal overlay 内的点击不拦截 */
          if (e.target.closest(".m26-modal-overlay")) return;
          const shareBtn = e.target.closest("[data-share-type]");
          if (shareBtn) {
            this._share(shareBtn.dataset.shareType);
            return;
          }
          this._openModal();
        }
        _openModal() {
          /* cookie 可能已被删除，打开弹框前重新校验登录态 */
          pdSyncM26AuthFromCookie();
          const auth = pdGetM26Auth();
          if (!auth || !auth.user) {
            pdLoginForEl(this);
            return;
          }
          const tpl = this.querySelector("template");
          if (!tpl) return;
          if (!this._modal)
            this._modal = new M26ModalLocal("m26-share-panel__modal");
          this._modal.setContent(tpl.innerHTML);
          this._modal.show();
          if (this._modal._boxEl) {
            this._modal._boxEl
              .querySelectorAll("[data-share-type]")
              .forEach((btn) => {
                btn.addEventListener(
                  "click",
                  () => {
                    this._share(btn.dataset.shareType);
                  },
                  { once: true },
                );
              });
          }
        }
        _share(type) {
          /* modal 内点击分享时再次校验，防止 cookie 已被删除 */
          pdSyncM26AuthFromCookie();
          const auth = pdGetM26Auth();
          if (!auth || !auth.user) {
            if (this._modal) this._modal.close();
            pdLoginForEl(this);
            return;
          }
          const url = window.location.href;
          const encoded = encodeURIComponent(url);
          switch (type) {
            case "copy":
              navigator.clipboard.writeText(url).catch(() => {});
              break;
            case "facebook":
              window.open(
                `https://www.facebook.com/sharer/sharer.php?u=${encoded}`,
                "facebook-share",
                "width=626,height=436,noopener,noreferrer",
              );
              break;
            case "twitter":
              window.open(
                `https://twitter.com/intent/tweet?url=${encoded}&hashtags=${encodeURIComponent("momcozy")}`,
                "_blank",
                "width=550,height=420,noopener,noreferrer",
              );
              break;
            case "pinterest":
              window.open(
                `https://www.pinterest.com/pin/create/button/?url=${encoded}`,
                "pinterest-share",
                "width=750,height=630,noopener,noreferrer",
              );
              break;
            case "instagram":
              window.open(
                "https://www.instagram.com/",
                "_blank",
                "noopener,noreferrer",
              );
              break;
            case "email": {
              const subject = encodeURIComponent(`Share: ${document.title}`);
              window.open(
                `mailto:?subject=${subject}&body=${url}`,
                "_blank",
                "noopener,noreferrer",
              );
              break;
            }
          }
          if (this._modal) this._modal.close();
          this.dispatchEvent(
            new CustomEvent("m26:shared", { bubbles: true, detail: { type } }),
          );
        }
      }
      customElements.define("m26-share-panel", M26SharePanel);
    }

    m26ToastLocal = function (
      message,
      { duration = 3000, container = null } = {},
    ) {
      const el = document.createElement("div");
      el.className = "m26-toast";
      el.innerHTML = `<svg class="m26-toast__icon" viewBox="0 0 24 24" fill="none"><use xlink:href="#m26-toast-success"></use></svg><span class="m26-toast__text">${message}</span>`;
      (container || document.body).appendChild(el);
      requestAnimationFrame(() => el.classList.add("is-visible"));
      setTimeout(() => {
        el.classList.remove("is-visible");
        el.addEventListener("transitionend", () => el.remove(), { once: true });
        setTimeout(() => el.remove(), 400);
      }, duration);
    };

    let _m26TipPopup = null;
    m26ApiErrorTipLocal = function (err) {
      const tips = m26I18nLocal.get("tips");
      let msg = "";
      let className = "";
      const code = err && err.code;

      if (code === "10004270") {
        msg = tips.ended_html || "<strong>The event has ended!</strong>";
      } else if (code === "10004269") {
        msg =
          tips.not_started_html ||
          "<strong>The event hasn't started yet!</strong>";
      } else if (code === "10004271") {
        msg =
          tips.no_today_html ||
          "<strong>Select today's date to unlock your draw!</strong>";
      } else if (code === "10001003") {
        msg = tips.login_expired || "Login has expired, please login again.";
        if (m26AuthLocal) m26AuthLocal.user = null;
        document.dispatchEvent(new CustomEvent("lute:account:logout"));
      } else {
        className = "m26-win__card--long-txt";
        msg =
          tips.next_time_error_html ||
          "Sorry, you did not win a prize.<br> Please try again next time.";
      }

      if (!_m26TipPopup) {
        _m26TipPopup = document.createElement("m26-win-popup");
        document.body.appendChild(_m26TipPopup);
      }

      _m26TipPopup.show({
        prizeInfo: {
          prizeType: 0,
          prizeName: "",
          _overrideTxt: msg,
          _className: className,
        },
      });
    };

    class _M26Lottery {
      static scrollToEl(el) {
        if (!el) return;
        const stickyEls = document.querySelectorAll(
          ".m26-nav.is-sticky, .m26-nav.is-fixed-top, [data-header-sticky]",
        );
        let offset = 0;
        stickyEls.forEach((s) => {
          offset += s.getBoundingClientRect().height;
        });
        const top =
          el.getBoundingClientRect().top + window.scrollY - offset - 20;
        const reduceMotion =
          window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        window.scrollTo({
          top: Math.max(0, top),
          behavior: reduceMotion ? "auto" : "smooth",
        });
      }

      constructor({ el, scrollTarget, activityType } = {}) {
        this._el = el || document;
        this._scrollTarget = scrollTarget || null;
        this._chances = 0;
        this._activityType = activityType || window.__MC_ACTIVITY_TYPE__ || "";
        this._onShared = () => {
          this._saveShare();
        };
        m26AuthLocal.onLogin(() => this.refreshChances());
        this._el.addEventListener("m26:shared", this._onShared);
      }

      get chances() {
        return this._chances;
      }

      async _fetch(path, opts = {}) {
        return m26FetchLocal(path, opts);
      }
      async refreshChances() {
        if (!m26AuthLocal.user) {
          this._chances = 0;
          return 0;
        }
        try {
          const res = await this._fetch(
            `/api/station/activity/raffle/queryRaffleNumber?activityType=${encodeURIComponent(this._activityType)}`,
          );
          const raw = res && typeof res === "object" ? res.result : res;
          const num = Number(raw) || 0;
          this._chances = num <= 0 ? 0 : num;
        } catch (err) {
          this._chances = 0;
          throw err;
        }
        this._el.dispatchEvent(
          new CustomEvent("m26:chances-updated", {
            bubbles: true,
            detail: { chances: this._chances },
          }),
        );
        return this._chances;
      }
      async _saveShare() {
        if (!m26AuthLocal.user || !m26AuthLocal.user.email) return;
        try {
          const res = await this._fetch(
            "/api/station/activity/raffle/saveShareInfoByConfig",
            {
              method: "POST",
              body: JSON.stringify({
                activityType: this._activityType,
                shareType: 0,
                type: 1,
                email: m26AuthLocal.user.email,
              }),
            },
          );
          if (res && res.status === 1) {
            this.refreshChances();
            const shareI18n = m26I18nLocal.get("share");
            m26ToastLocal(shareI18n.toast || "+1 chance to win", {
              container: this._scrollTarget,
            });
            if (this._scrollTarget) _M26Lottery.scrollToEl(this._scrollTarget);
          }
        } catch (err) {
          if (err && err.code === "10001003") {
            if (m26LoginLocal) m26LoginLocal();
          }
        }
      }

      async checkAndStart() {
        if (!m26AuthLocal.user) {
          if (m26LoginLocal) m26LoginLocal();
          return null;
        }
        await this._fetch("/api/station/activity/raffle/checkStatus", {
          method: "POST",
          body: JSON.stringify({ activityType: this._activityType }),
        });
        const chances = await this.refreshChances();
        if (chances < 1) return { noChances: true };
        return this._startRaffle();
      }
      async _startRaffle() {
        /* 开启多 SKU 时后端走 startShopRaffleAuth（新抽奖流程） */
        const endpoint = this._skuEnabled
          ? "/api/station/activity/raffle/startShopRaffleAuth"
          : "/api/station/activity/raffle/startRaffleAuth";
        const res = await this._fetch(
          `${endpoint}?activityType=${encodeURIComponent(this._activityType)}` +
            (this._skuEnabled ? "&newRaffleFlow=true" : ""),
        );
        this.refreshChances();
        if (res.result === -1 && res.msg === "0") return { noChances: true };
        if (res.result < 0) throw res;
        return res;
      }
      destroy() {
        this._el.removeEventListener("m26:shared", this._onShared);
      }
    }
    M26LotteryLocal = _M26Lottery;

    if (!customElements.get("m26-address-select")) {
      class M26AddressSelect extends HTMLElement {
        connectedCallback() {
          this._modal = new M26ModalLocal("m26-address-select__modal");
          this._prizeCode = this.dataset.prizeCode || "";
          this._addresses = [];
          this._selected = null;
          this._loading = false;
          this._open();
        }

        disconnectedCallback() {
          if (this._modal) {
            this._modal.destroy();
            this._modal = null;
          }
        }

        async _open() {
          const i18n = m26I18nLocal.get("address");
          this._i18n = i18n;
          if (!this._modal) return;
          this._modal.setContent(
            `<div class="m26-addr"><h3 class="m26-addr__title">${this._esc(i18n.select_title)}</h3><div class="m26-addr__list"></div><div class="m26-addr__btns"></div></div>`,
          );
          this._modal.show();
          await this._loadAddresses();
        }

        async _loadAddresses() {
          try {
            const res = await m26FetchLocal("/api/station/user/address/list");
            this._addresses = (res && res.addressList) || [];
          } catch (_) {
            this._addresses = [];
          }
          if (!this.isConnected || !this._modal) return;
          if (this._addresses.length)
            this._selected = String(this._addresses[0].id);
          this._render();
        }

        _esc(str) {
          return str == null ? "" : String(str);
        }

        _render() {
          if (!this._modal) return;
          const body = this._modal._bodyEl;
          if (!body) return;
          const i = this._i18n;
          const list = this._addresses.slice(0, 5);

          let listHtml = "";
          if (list.length) {
            listHtml = list
              .map((a) => {
                const checked =
                  String(a.id) === this._selected ? "checked" : "";
                const tag =
                  a.defaultStatus === 1
                    ? `<span class="m26-addr__tag">${this._esc(i.default_tag)}</span>`
                    : "";
                return `<label class="m26-addr__item">
            <input type="radio" name="m26-addr" value="${a.id}" ${checked} class="m26-addr__radio">
            <div class="m26-addr__item-body">
              <div class="m26-addr__item-name">${this._esc(a.firstName)} ${this._esc(a.lastName)} (${this._esc(a.phone)}) ${tag}</div>
              <div class="m26-addr__item-addr">${this._esc(a.address1)} ${this._esc(a.address2 || "")} ${this._esc(a.city)}</div>
            </div>
          </label>`;
              })
              .join("");
          }

          let btnsHtml = "";
          if (list.length) {
            btnsHtml = `<button type="button" class="m26-addr__btn m26-addr__btn--confirm" ${this._loading ? "disabled" : ""}>${this._esc(i.confirm_btn)}</button>`;
            if (list.length < 5) {
              btnsHtml += `<button type="button" class="m26-addr__btn m26-addr__btn--add">${this._esc(i.add_btn)}</button>`;
            }
          } else {
            btnsHtml = `<button type="button" class="m26-addr__btn m26-addr__btn--confirm m26-addr__btn--add-only">${this._esc(i.add_btn)}</button>`;
          }

          const btnsClass = list.length
            ? "m26-addr__btns"
            : "m26-addr__btns m26-addr__btns--empty";
          body.innerHTML = `<div class="m26-addr"><h3 class="m26-addr__title">${this._esc(i.select_title)}</h3><div class="m26-addr__list">${listHtml}</div><div class="${btnsClass}">${btnsHtml}</div></div>`;

          body.querySelectorAll(".m26-addr__radio").forEach((radio) => {
            radio.addEventListener("change", () => {
              this._selected = radio.value;
            });
          });

          const confirmBtn = body.querySelector(".m26-addr__btn--confirm");
          if (confirmBtn && list.length) {
            confirmBtn.addEventListener("click", () => this._confirm());
          } else if (confirmBtn) {
            confirmBtn.addEventListener("click", () => this._openAddForm());
          }

          const addBtn = body.querySelector(".m26-addr__btn--add");
          if (addBtn)
            addBtn.addEventListener("click", () => this._openAddForm());
        }

        async _confirm() {
          if (this._loading || !this._selected) return;
          this._loading = true;
          this._render();
          try {
            const activityType = window.__MC_ACTIVITY_TYPE__ || "";
            const qs = `?activityType=${encodeURIComponent(activityType)}&addressId=${this._selected}&activityUserPrizeCode=${encodeURIComponent(this._prizeCode)}`;
            await m26FetchLocal(
              `/api/station/activity/raffle/saveRaffleAddress${qs}`,
            );
            document.dispatchEvent(new CustomEvent("m26:address-saved"));
            this._modal.close();
            this.remove();
          } catch (_) {
          } finally {
            this._loading = false;
          }
        }

        _openAddForm() {
          const form = document.createElement("m26-address-form");
          document.body.appendChild(form);
          document.addEventListener(
            "m26:address-added",
            () => {
              this._loadAddresses();
            },
            { once: true },
          );
        }
      }

      customElements.define("m26-address-select", M26AddressSelect);
    }

    if (!customElements.get("m26-select")) {
      class M26Select extends HTMLElement {
        constructor() {
          super();
          this._items = [];
          this._value = "";
          this._isOpen = false;
          this._focusIdx = -1;
          this._typeStr = "";
          this._typeTimer = 0;
        }

        connectedCallback() {
          this._placeholder = this.getAttribute("placeholder") || "";
          if (!this._domBuilt) {
            this._domBuilt = true;
            this._buildDOM();
          }
          this.addEventListener("click", this);
          this.addEventListener("keydown", this);
          this._outsideClick = (e) => {
            if (this._isOpen && !this.contains(e.target)) this.close();
          };
          document.addEventListener("click", this._outsideClick);
        }

        disconnectedCallback() {
          this.removeEventListener("click", this);
          this.removeEventListener("keydown", this);
          document.removeEventListener("click", this._outsideClick);
          this._stopFloating();
        }

        handleEvent(e) {
          if (e.type === "click") this._onClick(e);
          else if (e.type === "keydown") this._onKeydown(e);
        }

        _onClick(e) {
          e.stopPropagation();
          if (this.hasAttribute("disabled")) return;
          const item = e.target.closest('[data-slot="select-item"]');
          if (item) {
            this._select(item.dataset.value);
            this.close();
            this._trigger.focus();
            return;
          }
          if (e.target.closest('[data-slot="select-trigger"]')) {
            this._isOpen ? this.close() : this.open();
          }
        }

        _onKeydown(e) {
          if (this.hasAttribute("disabled")) return;
          const items = [...this._viewport.children];
          if (!items.length && e.key !== "Escape") return;

          switch (e.key) {
            case "Escape":
              if (this._isOpen) {
                e.preventDefault();
                this.close();
                this._trigger.focus();
              }
              break;
            case "ArrowDown":
              e.preventDefault();
              if (!this._isOpen) {
                this.open();
                break;
              }
              this._focusIdx = Math.min(this._focusIdx + 1, items.length - 1);
              this._highlight(items);
              break;
            case "ArrowUp":
              e.preventDefault();
              if (!this._isOpen) {
                this.open();
                break;
              }
              this._focusIdx = Math.max(this._focusIdx - 1, 0);
              this._highlight(items);
              break;
            case "Enter":
            case " ":
              e.preventDefault();
              if (!this._isOpen) {
                this.open();
                return;
              }
              if (this._focusIdx >= 0 && this._focusIdx < items.length) {
                this._select(items[this._focusIdx].dataset.value);
                this.close();
                this._trigger.focus();
              }
              break;
            case "Home":
              if (this._isOpen) {
                e.preventDefault();
                this._focusIdx = 0;
                this._highlight(items);
              }
              break;
            case "End":
              if (this._isOpen) {
                e.preventDefault();
                this._focusIdx = items.length - 1;
                this._highlight(items);
              }
              break;
            default:
              if (e.key.length === 1 && this._isOpen) {
                clearTimeout(this._typeTimer);
                this._typeStr += e.key.toLowerCase();
                this._typeTimer = setTimeout(() => {
                  this._typeStr = "";
                }, 500);
                const idx = items.findIndex((i) =>
                  (i.textContent || "")
                    .trim()
                    .toLowerCase()
                    .startsWith(this._typeStr),
                );
                if (idx >= 0) {
                  this._focusIdx = idx;
                  this._highlight(items);
                }
              }
          }
        }

        get value() {
          return this._value;
        }
        set value(v) {
          this._value = v;
          this._syncUI();
        }

        setItems(list) {
          this._items = (list || []).map((i) =>
            typeof i === "string" ? { value: i, label: i } : i,
          );
          this._value = "";
          this._renderItems();
          this._syncUI();
        }

        open() {
          document.querySelectorAll("m26-select").forEach((s) => {
            if (s !== this && s._isOpen) s.close();
          });
          this._isOpen = true;
          this._trigger.setAttribute("aria-expanded", "true");
          this._content.dataset.state = "open";
          const items = [...this._viewport.children];
          this._focusIdx = items.findIndex(
            (i) => i.dataset.value === this._value,
          );
          if (this._focusIdx < 0 && items.length) this._focusIdx = 0;
          this._highlight(items);
          this._startFloating();
        }

        close() {
          this._isOpen = false;
          this._focusIdx = -1;
          this._trigger.setAttribute("aria-expanded", "false");
          this._content.dataset.state = "closed";
          this._stopFloating();
        }

        static _floatingCore = {
          tagId: "floating-ui-core",
          src: "https://cdn.jsdelivr.net/npm/@floating-ui/core@1.7.3",
          type: "script",
        };
        static _floatingDom = {
          tagId: "floating-ui-dom",
          src: "https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.7.4",
          type: "script",
        };
        static _floatingPromise = null;
        static _loadFloatingUI() {
          if (M26Select._floatingPromise) return M26Select._floatingPromise;
          if (window.FloatingUIDOM)
            return (M26Select._floatingPromise = Promise.resolve(
              window.FloatingUIDOM,
            ));
          const u = window.luteUtil;
          if (!u) return Promise.reject();
          M26Select._floatingPromise = u
            .loadLibrary(M26Select._floatingCore)
            .then(() => u.loadLibrary(M26Select._floatingDom))
            .then(() => window.FloatingUIDOM);
          return M26Select._floatingPromise;
        }

        async _startFloating() {
          let F;
          try {
            F = await M26Select._loadFloatingUI();
          } catch (_) {
            /* FloatingUI 不可用（如 luteUtil 未加载），降级为原生 getBoundingClientRect 静态定位 */
            this._fallbackPosition();
            return;
          }
          if (!this._isOpen) return;
          const reference = this._trigger;
          const floating = this._content;
          const update = () => {
            F.computePosition(reference, floating, {
              placement: "bottom-start",
              strategy: "absolute",
              middleware: [
                F.offset(4),
                F.flip({ padding: 8 }),
                F.shift({ padding: 8 }),
                F.size({
                  apply({ rects, elements }) {
                    Object.assign(elements.floating.style, {
                      width: `${rects.reference.width}px`,
                    });
                  },
                  padding: 8,
                }),
              ],
            }).then(({ x, y, placement }) => {
              Object.assign(floating.style, {
                left: `${x}px`,
                top: `${y}px`,
              });
              floating.dataset.side = placement.split("-")[0];
            });
          };
          this._cleanupAutoUpdate = F.autoUpdate(reference, floating, update);
        }

        _fallbackPosition() {
          if (!this._isOpen) return;
          const floating = this._content;
          const triggerH = this._trigger.offsetHeight;
          const floatingH = floating.offsetHeight || 350;
          const gap = 4;
          /* position:absolute 相对 m26-select 自身定位，直接用 offsetHeight 计算即可
             无需 getBoundingClientRect，不受祖先 transform / will-change 干扰 */
          const selectH = this.offsetHeight;
          const spaceBelow =
            window.innerHeight - this.getBoundingClientRect().bottom;
          let top, side;
          if (
            spaceBelow >= floatingH + gap ||
            spaceBelow >= this.getBoundingClientRect().top
          ) {
            top = selectH + gap;
            side = "bottom";
          } else {
            top = -(floatingH + gap);
            side = "top";
          }
          Object.assign(floating.style, {
            left: "0px",
            top: `${top}px`,
            width: `${this._trigger.offsetWidth}px`,
          });
          floating.dataset.side = side;
        }

        _stopFloating() {
          if (this._cleanupAutoUpdate) {
            this._cleanupAutoUpdate();
            this._cleanupAutoUpdate = null;
          }
        }

        get validity() {
          const req = this.hasAttribute("required");
          return {
            valid: !req || !!this._value,
            valueMissing: req && !this._value,
          };
        }
        checkValidity() {
          return this.validity.valid;
        }
        reportValidity() {
          if (this.checkValidity()) return true;
          this.dataset.invalid = "";
          return false;
        }

        _buildDOM() {
          const uid = "m26sl_" + Math.random().toString(36).slice(2, 8);
          this.dataset.slot = "select";

          const trigger = document.createElement("button");
          trigger.type = "button";
          trigger.dataset.slot = "select-trigger";
          trigger.setAttribute("role", "combobox");
          trigger.setAttribute("aria-haspopup", "listbox");
          trigger.setAttribute("aria-expanded", "false");
          trigger.setAttribute("aria-controls", uid);

          const valueEl = document.createElement("span");
          valueEl.dataset.slot = "select-value";
          valueEl.dataset.placeholder = "";
          valueEl.textContent = this._placeholder;

          const icon = document.createElement("svg");
          icon.dataset.slot = "select-icon";
          icon.innerHTML = '<use href="#m26-select-arrow"/>';

          trigger.append(valueEl, icon);

          const content = document.createElement("div");
          content.dataset.slot = "select-content";
          content.dataset.state = "closed";
          content.dataset.position = "popper";
          content.id = uid;
          content.setAttribute("role", "listbox");

          const viewport = document.createElement("div");
          viewport.dataset.slot = "select-viewport";
          content.appendChild(viewport);

          this.append(trigger, content);
          this._trigger = trigger;
          this._valueEl = valueEl;
          this._content = content;
          this._viewport = viewport;
        }

        _renderItems() {
          this._viewport.innerHTML = "";
          for (const item of this._items) {
            const el = document.createElement("button");
            el.type = "button";
            el.dataset.slot = "select-item";
            el.dataset.value = item.value;
            el.setAttribute("role", "option");
            el.setAttribute("aria-selected", "false");

            const text = document.createElement("span");
            text.dataset.slot = "select-item-text";
            text.textContent = item.label;

            const indicator = document.createElement("span");
            indicator.dataset.slot = "select-item-indicator";
            indicator.innerHTML =
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>';

            el.append(text, indicator);
            this._viewport.appendChild(el);
          }
        }

        _select(val) {
          if (val === this._value) return;
          this._value = val;
          delete this.dataset.invalid;
          this._syncUI();
          this.dispatchEvent(new Event("change", { bubbles: true }));
        }

        _syncUI() {
          const found = this._items.find((i) => i.value === this._value);
          if (found) {
            this._valueEl.textContent = found.label;
            delete this._valueEl.dataset.placeholder;
          } else {
            this._valueEl.textContent = this._placeholder;
            this._valueEl.dataset.placeholder = "";
          }
          this._viewport
            .querySelectorAll('[data-slot="select-item"]')
            .forEach((el) => {
              el.setAttribute(
                "aria-selected",
                el.dataset.value === this._value ? "true" : "false",
              );
            });
        }

        _highlight(items) {
          items.forEach((el, i) => {
            if (i === this._focusIdx) {
              el.dataset.highlighted = "";
              el.scrollIntoView({ block: "nearest" });
            } else {
              delete el.dataset.highlighted;
            }
          });
        }
      }
      customElements.define("m26-select", M26Select);
    }

    if (!customElements.get("m26-address-form")) {
      class M26AddressForm extends HTMLElement {
        static _zodLib = {
          tagId: "zod",
          src: "https://cdn.jsdelivr.net/npm/zod@4/+esm",
          type: "module",
        };
        static _z = null;
        static _zodPromise = null;
        static _loadZod() {
          if (M26AddressForm._z) return Promise.resolve(M26AddressForm._z);
          if (M26AddressForm._zodPromise) return M26AddressForm._zodPromise;
          const u = window.luteUtil;
          if (!u) return Promise.reject();
          M26AddressForm._zodPromise = u
            .loadLibrary(M26AddressForm._zodLib)
            .then((mod) => {
              const z =
                mod &&
                (mod.z || (mod.default && mod.default.z) || mod.default || mod);
              M26AddressForm._z = z;
              return z;
            });
          return M26AddressForm._zodPromise;
        }

        connectedCallback() {
          this._modal = new M26ModalLocal("m26-address-form__modal");
          this._loading = false;
          this._countries = [];
          this._provinces = [];
          this._form = {
            firstName: "",
            lastName: "",
            company: "",
            phone: "",
            address1: "",
            address2: "",
            city: "",
            zipCode: "",
            country: "",
            province: "",
          };
          this._open();
        }

        disconnectedCallback() {
          if (this._modal) {
            this._modal.destroy();
            this._modal = null;
          }
        }

        async _open() {
          const tpl = document.getElementById("m26-addr-form-tpl");
          if (!tpl) return;
          const content = tpl.content.cloneNode(true);
          const wrapper = document.createElement("div");
          wrapper.appendChild(content);
          this._modal.setContent(wrapper.innerHTML);
          this._modal.show();

          this._bind();
          await Promise.all([
            this._loadCountries(),
            M26AddressForm._loadZod().catch(() => null),
          ]);
        }

        _bind() {
          const body = this._modal._bodyEl;
          if (!body) return;

          this._countrySelect = body.querySelector(
            'm26-select[name="country"]',
          );
          this._provinceSelect = body.querySelector(
            'm26-select[name="province"]',
          );
          this._errEl = body.querySelector(".m26-addr-form__error");
          this._submitBtn = body.querySelector('button[type="submit"]');

          body.querySelectorAll("input").forEach((el) => {
            el.addEventListener("input", () => {
              this._form[el.name] = el.value;
              this._clearFieldError(el);
            });
          });

          if (this._countrySelect) {
            this._countrySelect.addEventListener("change", () => {
              this._form.country = this._countrySelect.value;
              this._clearFieldError(this._countrySelect);
              this._loadProvinces();
            });
          }

          if (this._provinceSelect) {
            this._provinceSelect.addEventListener("change", () => {
              this._form.province = this._provinceSelect.value;
              this._clearFieldError(this._provinceSelect);
            });
          }

          const form = body.querySelector("form");
          if (form) {
            form.addEventListener("submit", (e) => {
              e.preventDefault();
              this._submit();
            });
          }
        }

        async _loadCountries() {
          try {
            const res = await m26FetchLocal("/api/base/region/countryList/v2", {
              method: "POST",
              body: JSON.stringify({ langCode: "EN_US" }),
            });
            this._countries = res || [];
          } catch (_) {
            this._countries = [];
          }
          if (this._countrySelect)
            this._countrySelect.setItems(
              this._countries.map((c) => c.regionName),
            );
        }

        async _loadProvinces() {
          const item = this._countries.find(
            (c) => c.regionName === this._form.country,
          );
          if (!item) {
            this._provinces = [];
            if (this._provinceSelect) {
              this._provinceSelect.setItems([]);
              this._provinceSelect.setAttribute("disabled", "");
            }
            return;
          }
          try {
            const res = await m26FetchLocal("/api/base/region/provinceList", {
              method: "POST",
              body: JSON.stringify({
                iso2: item.iso2,
                iso3: item.iso3,
                langCode: "EN_US",
              }),
            });
            this._provinces = res || [];
          } catch (_) {
            this._provinces = [];
          }
          this._form.province = "";
          if (this._provinceSelect) {
            this._provinceSelect.setItems(
              this._provinces.map((p) => p.admName),
            );
            if (this._provinces.length) {
              this._provinceSelect.setAttribute("required", "");
              this._provinceSelect.removeAttribute("disabled");
            } else {
              this._provinceSelect.removeAttribute("required");
              this._provinceSelect.setAttribute("disabled", "");
            }
          }
        }

        _buildSchema() {
          const z = M26AddressForm._z;
          if (!z) return null;
          const t = m26I18nLocal.get("address");
          const hasProvinces = this._provinces.length > 0;
          return z.object({
            firstName: z
              .string()
              .min(1, t.v_first_name || "Required")
              .max(50),
            lastName: z
              .string()
              .min(1, t.v_last_name || "Required")
              .max(50),
            company: z.string().max(198),
            phone: z
              .string()
              .min(1, t.v_phone || "Required")
              .max(30),
            address1: z
              .string()
              .min(1, t.v_address1 || "Required")
              .max(300),
            address2: z.string().max(300),
            city: z
              .string()
              .min(1, t.v_city || "Required")
              .max(72),
            zipCode: z
              .string()
              .min(1, t.v_zip_code || "Required")
              .max(32),
            country: z.string().min(1, t.v_country || "Required"),
            province: hasProvinces
              ? z.string().min(1, t.v_province || "Required")
              : z.string(),
          });
        }

        _validate() {
          this._clearAllErrors();
          const schema = this._buildSchema();
          if (!schema) return true;
          const result = schema.safeParse(this._form);
          if (result.success) return true;
          const shown = new Set();
          for (const issue of result.error.issues) {
            const name = String(issue.path[0]);
            if (!shown.has(name)) {
              shown.add(name);
              this._showFieldError(name, issue.message);
            }
          }
          const firstErr =
            this._modal._bodyEl &&
            this._modal._bodyEl.querySelector(".m26-addr-form__field.is-error");
          if (firstErr)
            firstErr.scrollIntoView({ block: "nearest", behavior: "smooth" });
          return false;
        }

        _showFieldError(name, message) {
          const body = this._modal._bodyEl;
          if (!body) return;
          const el = body.querySelector(`[name="${name}"]`);
          if (!el) return;
          const field = el.closest(".m26-addr-form__field");
          if (!field) return;
          field.classList.add("is-error");
          let errEl = field.querySelector(".m26-addr-form__field-error");
          if (!errEl) {
            errEl = document.createElement("div");
            errEl.className = "m26-addr-form__field-error";
            field.appendChild(errEl);
          }
          errEl.textContent = message;
        }

        _clearFieldError(el) {
          const field = el.closest(".m26-addr-form__field");
          if (!field || !field.classList.contains("is-error")) return;
          field.classList.remove("is-error");
          const errEl = field.querySelector(".m26-addr-form__field-error");
          if (errEl) errEl.remove();
        }

        _clearAllErrors() {
          const body = this._modal._bodyEl;
          if (!body) return;
          body
            .querySelectorAll(".m26-addr-form__field.is-error")
            .forEach((f) => {
              f.classList.remove("is-error");
              const e = f.querySelector(".m26-addr-form__field-error");
              if (e) e.remove();
            });
        }

        async _submit() {
          const valid = await this._validate();
          if (!valid) return;

          if (this._loading) return;
          this._loading = true;
          if (this._submitBtn) this._submitBtn.disabled = true;
          if (this._errEl) this._errEl.hidden = true;
          try {
            await m26FetchLocal("/api/station/user/address/modify", {
              method: "POST",
              body: JSON.stringify(this._form),
            });
            document.dispatchEvent(new CustomEvent("m26:address-added"));
            this._modal.close();
            this.remove();
          } catch (err) {
            if (this._errEl) {
              this._errEl.textContent =
                (err && err.message) || "Error occurred";
              this._errEl.hidden = false;
            }
          } finally {
            this._loading = false;
            if (this._submitBtn) this._submitBtn.disabled = false;
          }
        }
      }

      customElements.define("m26-address-form", M26AddressForm);
    }

    if (!customElements.get("m26-win-popup")) {
      class M26WinPopup extends HTMLElement {
        connectedCallback() {
          this._modal = new M26ModalLocal("m26-win-popup__modal");
          this._prizeInfo = null;
          this._anchor = null;
        }
        disconnectedCallback() {
          if (this._modal) {
            this._modal.destroy();
            this._modal = null;
          }
        }
        show({ prizeInfo, anchor = null }) {
          this._prizeInfo = prizeInfo;
          this._anchor = anchor;
          /* 透传 PdlotteryApp 注入的开关状态（prizeInfo._skuEnabled / prizeInfo._skuOpenable
             由 _maybeWrapForSku 在 _showWinPopup 中设置），让 _renderWinContainer
             能直接 this._skuEnabled / this._skuOpenable 访问。 */
          this._skuEnabled = !!(prizeInfo && prizeInfo._skuEnabled);
          this._skuOpenable = !!(prizeInfo && prizeInfo._skuOpenable);
          /* coupon_tip_override：仅 prizeType=3 由 _showWinPopup 注入，
             覆盖 i.tips_prefix_html，留空走 i18n 默认值。 */
          this._couponTipOverride = !!(prizeInfo && prizeInfo._couponTipOverride)
            ? String(prizeInfo._couponTipOverride)
            : "";
          this._render();
        }
        _esc(str) {
          return str == null ? "" : String(str);
        }
        _renderWinContainer(i, p, type, imgs = {}) {
          const isCongrats = [1, 2, 3, 5, 8, 10].includes(type);
          const titleText = isCongrats
            ? this._esc(i.congrats || "Congratulations!")
            : "";

          let txtHtml = "";
          let imgHtml = "";
          let tipsHtml = "";
          let btnText = i.btn_ok || "OK";
          let btnAction = "close";
          let btnCode = "";
          let txtClass = "m26-win__txt";
          let imgClass = "m26-win__img";
          let cardClass = "m26-win__card";
          if (p._className) cardClass += " " + p._className;

          if ([1, 2, 3, 5, 7].includes(type)) {
            txtHtml = (i.youve_won_html || "").replace(
              "__PRIZE__",
              `<strong>${this._esc(p.prizeName)}</strong>`,
            );
            imgHtml = `<img src="${this._esc(p.prizeImg || p.prizeUrl || p.image || "")}" alt="${this._esc(p.prizeName)}" width="156" height="156">`;

            if (type === 1) {
              //prizeType为1表示是实物奖品
              cardClass += " m26-win__card--physical";
              /* 多 SKU 开关 + 条件命中：把按钮 action 从 'address'（地址表单）切换为 'open-sku'，
                 由 PdlotteryApp._openSkuDialog 唤起 pd-sku 多 SKU 弹框。
                 这里 text 保持与原 btn_submit 一致；如需换成"Select Variant"再调 i18n。 */
              if (this._skuEnabled) {
                if (this._skuOpenable) {
                  btnAction = "open-sku";
                  btnText = i.select_prize_btn || "Select Your Prize";
                } else {
                  btnText = i.claim_btn || "Claim";
                  btnAction = "claim";
                }
                tipsHtml = this._esc(p.prizeDesc || "");
              } else {
                btnText = i.btn_submit || "Submit";
                btnAction = "address";
                tipsHtml = this._esc(i.tips_address || "");
              }
            } else if (type === 3 || type === 5 || type == 7) {
              cardClass += " m26-win__card--coupon";
              /* prizeType=3 时优先使用 section 配置的 coupon_tip_override（自动拼接 Code 行）；
                 否则用 i18n 默认值（已含 Code 行）。prizeType=5/7 总是走 i18n 默认。 */
              const tipSource =
                type === 3 && this._couponTipOverride
                  ? `${this._couponTipOverride} <br> Code: __CODE__`
                  : i.tips_prefix_html || "";
              tipsHtml = tipSource.replace(
                "__CODE__",
                `<strong>${this._esc(p.couponCode)}</strong>`,
              );
              btnText = i.btn_copy_code || "Copy Code";
              btnAction = "copy";
              btnCode = p.couponCode || "";
            } else if (type === 2) {
              //如果是积分需要显示积分的提示
              tipsHtml =
                i.check_cozycoins_html ||
                'Please check in"Member Hub > CozyCoins"';
            }
          } else if (type === 10) {
            cardClass += " m26-win__card--guidance";
            txtHtml = (i.youve_won_html || "").replace(
              "__PRIZE__",
              `<strong>${this._esc(p.prizeName)}</strong>`,
            );
            imgHtml = `<img src="${this._esc(p.prizeUrl)}" alt="${this._esc(p.prizeName)}" width="156" height="156">`;
            imgClass += " m26-win__img--guidance";
            tipsHtml = "";
            btnText = i.btn_claim || "Claim My Prize";
            btnAction = "link";
          } else if (type === 8) {
            cardClass += " m26-win__card--retry";
            txtHtml = (i.youve_won_html || "").replace(
              "__PRIZE__",
              `<strong>${this._esc(i.one_more_chance || "One More Chance!")}</strong>`,
            );
            if (imgs.gift)
              imgHtml = `<img src="${this._esc(imgs.gift)}" alt="Gift Box" width="156" height="156">`;
            imgClass += " m26-win__img--gift";
            btnText = i.btn_try_again || "Try Again";
            btnAction = "retry";
          } else if (type === -1) {
            cardClass += " m26-win__card--no-chances";
            txtHtml = `${i.no_chances_html || "You've used up <br><strong>all your chances for now!</strong>"}`;
            if (imgs.heart)
              imgHtml = `<img src="${this._esc(imgs.heart)}" alt="Heart Box" width="156" height="156">`;
            txtClass += " m26-win__txt--no-chances";
            imgClass += " m26-win__img--heart";
          } else {
            cardClass += " m26-win__card--thanks";
            txtHtml =
              p._overrideTxt ||
              `${i.thank_you_html || "Thank You <br><strong>for Participating</strong>"}`;
            if (imgs.heart)
              imgHtml = `<img src="${this._esc(imgs.heart)}" alt="Heart Box" width="156" height="156">`;
            txtClass += " m26-win__txt--thanks";
            imgClass += " m26-win__img--heart";
          }

          const btnCodeAttr = btnCode
            ? ` data-code="${this._esc(btnCode)}"`
            : "";

          let btnHtml = "";
          if (btnAction === "link") {
            const href = p.benefitLink;
            btnHtml = `<a class="m26-win__btn" data-slot="btn" href="${this._esc(href)}" target="_blank" rel="noopener noreferrer">${this._esc(btnText)}</a>`;
          } else {
            btnHtml = `<button type="button" class="m26-win__btn" data-slot="btn" data-action="${btnAction}"${btnCodeAttr}>${this._esc(btnText)}</button>`;
          }

          return `
        <h3 class="m26-win__title" data-slot="title"${isCongrats ? "" : " hidden"}>${titleText}</h3>
        <div class="${cardClass}">
          <div class="${imgClass}" data-slot="img">${imgHtml}</div>
          <div class="${txtClass}" data-slot="txt">${txtHtml}</div>
          <div class="m26-win__tips" data-slot="tips">${tipsHtml}</div>
          ${btnHtml}
        </div>`;
        }

        _renderCloseIcon() {
          return `
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="24" y="24" width="24" height="24" rx="12" transform="rotate(-180 24 24)" fill="white" fill-opacity="0.75"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.29107 15.4163C9.09582 15.6116 8.7793 15.6115 8.58404 15.4163C8.38878 15.2211 8.38878 14.9045 8.58404 14.7093L11.293 12.0003L8.58404 9.29132C8.38878 9.09606 8.38878 8.77955 8.58404 8.58429C8.7793 8.38902 9.09581 8.38902 9.29107 8.58429L12.0001 11.2933L14.709 8.58429C14.9043 8.38902 15.2208 8.38902 15.4161 8.58429C15.6113 8.77955 15.6113 9.09607 15.4161 9.29132L12.7071 12.0003L15.4161 14.7093C15.6113 14.9046 15.6113 15.2211 15.4161 15.4163C15.2208 15.6116 14.9043 15.6115 14.709 15.4163L12.0001 12.7073L9.29107 15.4163Z" fill="#1A1A1A"/>
</svg>
          `;
        }

        _render() {
          const tpl = document.getElementById("m26-win-popup-tpl");
          if (!tpl) return;
          const content = tpl.content.cloneNode(true);
          const closeEl = content.querySelector(".m26-win__close");
          if (closeEl) {
            closeEl.innerHTML = this._renderCloseIcon();
          }
          const wrapper = document.createElement("div");
          wrapper.appendChild(content);

          const i = m26I18nLocal.get("win") || {};
          const p = this._prizeInfo;
          const type = p.prizeType;

          const containerEl = wrapper.querySelector(".m26-win__container");
          if (!containerEl) return;
          containerEl.dataset.type = String(type);
          const imgs = {
            gift: containerEl.dataset.imgGift || "",
            heart: containerEl.dataset.imgHeart || "",
          };
          containerEl.innerHTML = this._renderWinContainer(i, p, type, imgs);

          this._modal.setContent(wrapper.innerHTML);
          this._modal.show();
          const anchor = this._anchor || document.activeElement;
          const app =
            (anchor && anchor.closest && anchor.closest("pdlottery-app")) ||
            document.querySelector("pdlottery-app");
          const bg = pdGetSelectedCodeBg(app);
          pdSetSelectedCodeBgVars(
            this._modal && this._modal._boxEl,
            bg.pc,
            bg.mobile,
          );

          const body = this._modal._bodyEl;
          if (!body) return;

          /* 清理上次绑定的 click 监听器，防止多次 show 累积 */
          if (this._bodyClickHandler) {
            body.removeEventListener("click", this._bodyClickHandler);
          }
          this._bodyClickHandler = (e) => {
            const actionEl = e.target.closest("[data-action]");
            if (!actionEl) return;
            const action = actionEl.dataset.action;

            if (action === "close") {
              this._modal.close();
            } else if (action === "address") {
              this._handleAddress();
            } else if (action === "copy") {
              this._handleCopy(actionEl);
            } else if (action === "retry") {
              this._handleRetry();
            } else if (action === "open-sku") {
              /* 多 SKU 流程：派发自定义事件由 PdlotteryApp 接管唤起 lottery-common-sku */
              this.dispatchEvent(
                new CustomEvent("m26-win:open-sku", {
                  bubbles: true,
                  composed: true,
                  detail: { prizeInfo: this._prizeInfo },
                }),
              );
            } else if (action === "claim") {
              this._handleClaim();
            }
          };
          body.addEventListener("click", this._bodyClickHandler);
        }
        /* 单变体实物奖品领取：与 autumn _claimPrize 等价
           - 关闭 m26-win 弹框
           - 调用 queryClaimParams 接口拿 checkoutUrl
           - 跳转 Shopify checkout（window.location.href）
           - 出错时走 m26ApiErrorTipLocal 弹通用错误 toast
           实物奖品关闭后会自动跳转，无需 m26ApiErrorTipLocal 处理"redirect 后"的兜底。 */
        async _handleClaim() {
          const prize = this._prizeInfo;
          if (!prize || prize.prizeType !== 1) return;
          const button =
            this._modal && this._modal._boxEl
              ? this._modal._boxEl.querySelector(
                  ".m26-win__btn[data-slot='btn']",
                )
              : null;
          const prevDisabled = button ? button.disabled : false;
          if (button) {
            button.disabled = true;
            button.classList.add("is-loading");
            button.setAttribute("aria-busy", "true");
          }
          try {
            const qs = new URLSearchParams();
            qs.set("activityType", window.__MC_ACTIVITY_TYPE__ || "");
            qs.set("activityUserPrizeCode", prize.activityUserPrizeCode || "");
            if (prize.claimVariantId)
              qs.set("claimVariantId", String(prize.claimVariantId));
            const res = await m26FetchLocal(
              "/api/station/activity/raffle/queryClaimParams?" + qs.toString(),
            );
            const checkoutUrl = res && (res.checkoutUrl || res.url);
            if (checkoutUrl) {
              this._modal && this._modal.close();
              window.location.href = checkoutUrl;
            } else {
              m26ApiErrorTipLocal(res || { msg: "claimFailed" });
            }
          } catch (err) {
            m26ApiErrorTipLocal(err);
          } finally {
            /* 成功路径上 window.location.href 已跳转，finally 不会执行；
               错误路径上需要恢复按钮状态。 */
            if (button) {
              button.disabled = prevDisabled;
              button.classList.remove("is-loading");
              button.removeAttribute("aria-busy");
            }
          }
        }

        _handleAddress() {
          const prev = document.body.querySelector("m26-address-select");
          if (prev) prev.remove();
          const el = document.createElement("m26-address-select");
          el.dataset.prizeCode = this._prizeInfo.activityUserPrizeCode || "";
          document.body.appendChild(el);
          document.addEventListener(
            "m26:address-saved",
            () => {
              this._modal.close();
            },
            { once: true },
          );
        }

        _handleCopy(btn) {
          const code = btn.dataset.code;
          if (!code) return;
          navigator.clipboard.writeText(code);
          const i = m26I18nLocal.get("win") || {};
          const origText = btn.textContent;
          btn.textContent = i.copied || "Copied!";
          btn.classList.add("is-copied");
          setTimeout(() => {
            btn.textContent = origText;
            btn.classList.remove("is-copied");
          }, 2000);
        }

        _handleRetry() {
          this._modal.close();
          document.dispatchEvent(new CustomEvent("m26:retry"));
          if (this._anchor) {
            M26LotteryLocal.scrollToEl(this._anchor);
          }
        }
      }
      customElements.define("m26-win-popup", M26WinPopup);
    }
  }

  ensureM26Base();

  function pdGetCookie(name) {
    const key = `${encodeURIComponent(name)}=`;
    const parts = document.cookie.split(";");
    for (let i = 0; i < parts.length; i++) {
      const p = parts[i].trim();
      if (p.indexOf(key) === 0) return decodeURIComponent(p.slice(key.length));
    }
    return null;
  }

  function pdParseJwt(token) {
    try {
      const payload = token.split(".")[1];
      if (!payload) return null;
      const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
      const pad = "=".repeat((4 - (base64.length % 4)) % 4);
      return JSON.parse(atob(base64 + pad));
    } catch (_) {
      return null;
    }
  }

  function pdGetM26Auth() {
    if (m26AuthLocal) return m26AuthLocal;
    try {
      if (typeof m26Auth !== "undefined") return m26Auth;
    } catch (_) {}
    return null;
  }

  function pdSyncM26AuthFromCookie() {
    const auth = pdGetM26Auth();
    if (!auth) return;
    const cookieName =
      (window.__MC__CONFIG__ && window.__MC__CONFIG__.cookieName) ||
      "momcozy-token";
    const token = pdGetCookie(cookieName);
    if (!token) {
      /* cookie 不存在：
         - 由本函数写入的 cookie 来源态（type:"cookie"）→ 直接清空
         - 外部事件写入的态（type 非 "cookie"）→ 保留，避免 cookie 尚未写入时误清空 */
      if (auth.user && auth.user.type === "cookie") {
        auth.user = null;
      }
      return;
    }
    /* cookie 存在且与内存中 token 一致时无需重新解析 */
    if (auth.user && auth.user.token === token) return;
    /* cookie 存在但内存中 token 不一致（包含外部事件登录态 token 已失效的情况）→ 重新写入 */
    const payload = pdParseJwt(token) || {};
    auth.user = {
      type: "cookie",
      token,
      email: payload.email || payload.sub || "",
    };
  }

  document.addEventListener("LUTE:AUTH:LOGIN", (e) => {
    const auth = pdGetM26Auth();
    if (auth) auth.user = e.detail;
  });
  document.addEventListener("LUTE:AUTH:LOGOUT", () => {
    const auth = pdGetM26Auth();
    if (auth) auth.user = null;
  });

  /* ── 通用登录唤起：从触发元素向上找 pdlottery-app，优先带 hash 跳转 ── */
  function pdLoginForEl(el) {
    const app = el && el.closest && el.closest("pdlottery-app");
    if (app && typeof app._pdlLogin === "function") {
      app._pdlLogin();
    } else {
      if (m26LoginLocal) m26LoginLocal();
    }
  }

  function pdGetSelectedCodeBg(app) {
    if (!app) return { pc: "", mobile: "" };
    return {
      pc: app.dataset.selectedCodeBgPc || "",
      mobile: app.dataset.selectedCodeBgMobile || "",
    };
  }

  function pdSetSelectedCodeBgVars(el, pcUrl, mobileUrl) {
    if (!el) return;
    const pc = pcUrl ? `url("${pcUrl}")` : "none";
    const mobile = mobileUrl ? `url("${mobileUrl}")` : "none";
    el.style.setProperty("--pdl-selected-code-bg-pc", pc);
    el.style.setProperty("--pdl-selected-code-bg-mobile", mobile);
    if (pcUrl || mobileUrl) el.classList.add("pdlottery-has-code-bg");
    else el.classList.remove("pdlottery-has-code-bg");
  }

  function pdEnhanceDialogA11y(box) {
    if (!box) return;
    box.setAttribute("role", "dialog");
    box.setAttribute("aria-modal", "true");
    if (!box.hasAttribute("tabindex")) box.setAttribute("tabindex", "-1");

    const titleEl = box.querySelector("h1, h2, h3, [data-modal-title]");
    if (titleEl) {
      if (!titleEl.id)
        titleEl.id = "pdl_dlg_" + Math.random().toString(36).slice(2, 10);
      box.setAttribute("aria-labelledby", titleEl.id);
      box.removeAttribute("aria-label");
    } else if (!box.hasAttribute("aria-labelledby")) {
      if (!box.hasAttribute("aria-label"))
        box.setAttribute("aria-label", "Dialog");
    }

    const active = document.activeElement;
    if (active && box.contains(active)) return;

    const first = box.querySelector(
      '[data-close], [data-action="close"], button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );
    try {
      (first || box).focus({ preventScroll: true });
    } catch (_) {
      (first || box).focus();
    }
  }

  /* -- M26RulesPanel: reuse m26-mystery-box.js modal style -- */
  if (!customElements.get("m26-rules-panel")) {
    class M26RulesPanelLocal extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        this._modal = null;
        this.addEventListener("click", this);
      }
      disconnectedCallback() {
        this.removeEventListener("click", this);
        if (this._modal) {
          this._modal.destroy();
          this._modal = null;
        }
        const btn = this.querySelector("button[aria-expanded]");
        if (btn) btn.setAttribute("aria-expanded", "false");
      }
      handleEvent(e) {
        if (e.type !== "click") return;
        if (!e.target.closest(".m26-modal-overlay")) this._openModal();
      }
      _openModal() {
        const tpl = this.querySelector("template");
        if (!tpl) return;
        /* 移动端抽屉样式开关：当宿主元素标记 data-mobile-drawer="true" 时，
           给弹框追加 apl-modal--drawer 类，移动端样式化为底部抽屉。
           桌面端无任何影响，仍居中显示。 */
        const drawerCls =
          this.dataset && this.dataset.mobileDrawer === "true"
            ? "m26-rules-panel__modal apl-modal--drawer"
            : "m26-rules-panel__modal";
        if (!this._modal) this._modal = new M26ModalLocal(drawerCls);
        this._modal.setContent(tpl.innerHTML);
        this._modal.show();
        const btn = this.querySelector("button[aria-expanded]");
        if (btn) btn.setAttribute("aria-expanded", "true");
        /* modal 关闭后还原 aria-expanded：监听 box 上的 transitionend，
           每次打开都重新绑定，{ once: true } 保证只触发一次 */
        const restoreExpanded = () => {
          if (btn) btn.setAttribute("aria-expanded", "false");
        };
        if (this._modal._boxEl) {
          this._modal._boxEl.addEventListener(
            "transitionend",
            (ev) => {
              if (ev.target === this._modal._boxEl && !this._modal._isOpen)
                restoreExpanded();
            },
            { once: true },
          );
        }
      }
    }
    customElements.define("m26-rules-panel", M26RulesPanelLocal);
  }

  /* -- M26RecordPanel: reuse m26-mystery-box.js modal style -- */
  if (!customElements.get("m26-record-panel")) {
    class M26RecordPanelLocal extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        this._modal = null;
        this.addEventListener("click", this);
      }
      disconnectedCallback() {
        this.removeEventListener("click", this);
        if (this._modal) {
          this._modal.destroy();
          this._modal = null;
        }
        const btn = this.querySelector("button[aria-expanded]");
        if (btn) btn.setAttribute("aria-expanded", "false");
      }
      handleEvent(e) {
        if (e.type !== "click") return;
        if (!e.target.closest(".m26-modal-overlay")) this._openModal();
      }
      async _openModal() {
        /* cookie 可能已被删除，打开弹框前重新校验登录态 */
        pdSyncM26AuthFromCookie();
        const authCheck = pdGetM26Auth();
        if (!authCheck || !authCheck.user) {
          pdLoginForEl(this);
          return;
        }
        const tpl = this.querySelector("template");
        if (!tpl) return;
        if (!this._modal)
          this._modal = new M26ModalLocal("m26-record-panel__modal");
        this._modal.setContent(tpl.innerHTML);
        this._modal.show();
        const btn = this.querySelector("button[aria-expanded]");
        if (btn) btn.setAttribute("aria-expanded", "true");
        /* modal 关闭后还原 aria-expanded，每次打开重新绑定 */
        const restoreExpanded = () => {
          if (btn) btn.setAttribute("aria-expanded", "false");
        };
        if (this._modal._boxEl) {
          this._modal._boxEl.addEventListener(
            "transitionend",
            (ev) => {
              if (ev.target === this._modal._boxEl && !this._modal._isOpen)
                restoreExpanded();
            },
            { once: true },
          );
        }
        const emailEl =
          this._modal._bodyEl &&
          this._modal._bodyEl.querySelector("[data-m26-email]");
        if (emailEl) {
          const auth = pdGetM26Auth();
          if (auth && auth.user && auth.user.email)
            emailEl.textContent = "(" + auth.user.email + ")";
        }
        await this._loadRecords();
      }
      async _loadRecords() {
        const body = this._modal && this._modal._bodyEl;
        if (!body) return;
        pdSyncM26AuthFromCookie();
        const auth = pdGetM26Auth();
        const emptyEl = body.querySelector(".m26-record__empty");
        const listEl = body.querySelector(".m26-record__list");
        const skeletonEl = body.querySelector("[data-m26-record-skeleton]");
        if (!emptyEl || !listEl) return;
        /* 未登录时直接展示空态（同时关掉骨架屏） */
        if (!auth || !auth.user) {
          if (skeletonEl) skeletonEl.hidden = true;
          emptyEl.hidden = false;
          listEl.hidden = true;
          return;
        }
        /* 进入加载态：骨架屏显示，列表 / 空态隐藏。
           _openModal 首次进入时骨架屏立即可见，避免"白屏 → 内容"的闪烁。 */
        if (skeletonEl) skeletonEl.hidden = false;
        emptyEl.hidden = true;
        listEl.hidden = true;
        const i18n = m26I18nLocal ? m26I18nLocal.get("record") : {};
        /* 与 PdlotteryRecordModal._loadRecord / queryClaimParams 一致：
           开启多 SKU 时透传 newRaffleFlow=true，让后端走"新抽奖流程"返回 claimStatus 等字段。
           同时切换 endpoint 到 startShopRaffleAuth / queryShopWinningRecord */
        const skuEnabled = !!(
          this._skuEnabled ||
          (this.closest("pdlottery-app") &&
            this.closest("pdlottery-app")._skuEnabled)
        );
        try {
          const qs =
            "activityType=" +
            encodeURIComponent(
              this._activityType || window.__MC_ACTIVITY_TYPE__ || "",
            ) +
            (skuEnabled ? "&newRaffleFlow=true" : "");
          const endpoint = skuEnabled
            ? "/api/station/activity/raffle/queryShopWinningRecord"
            : "/api/station/activity/raffle/queryWinningRecord";
          const res = await m26FetchLocal(endpoint + "?" + qs);
          const beans = res && res.recordBeans;
          let items = [];
          if (Array.isArray(beans)) {
            items = beans;
          } else if (beans && typeof beans === "object") {
            Object.keys(beans).forEach(function (k) {
              const v = beans[k];
              items = items.concat(Array.isArray(v) ? v : [v]);
            });
          }
          /* 数据回来立即关掉骨架屏，避免后续 innerHTML 写入期间再次出现闪烁 */
          if (skeletonEl) skeletonEl.hidden = true;
          if (!items.length) {
            emptyEl.hidden = false;
            listEl.hidden = true;
            return;
          }
          emptyEl.hidden = true;
          listEl.hidden = false;
          /* 按 activityUserPrizeCode 缓存 record item，供 _handleRecordOpenSku
             读取 productId / productHandle / prizeName 等字段。 */
          this._recordsByCode = {};
          items.forEach(function (it) {
            if (it && it.activityUserPrizeCode)
              this._recordsByCode[it.activityUserPrizeCode] = it;
          }, this);
          listEl.innerHTML = items
            .map(function (item) {
              return this._renderItem(item, i18n);
            }, this)
            .join("");
          this._bindCopy(listEl);
        } catch (err) {
          /* 异常路径：关骨架屏 + 关弹框 + 弹错误 toast */
          if (skeletonEl) skeletonEl.hidden = true;
          if (this._modal) this._modal.close();
          if (m26ApiErrorTipLocal) m26ApiErrorTipLocal(err);
        }
      }
      _esc(str) {
        return str == null ? "" : String(str);
      }
      _renderItem(item, i18n) {
        /* 与 autumn _renderRecordItem 对齐：4 列网格（media / info / status+variant / ops）。
           SKU 开启时：
             - status 列显示 variant 子块（claimVariantTitle + Edit 按钮）
             - claimStatus=20 + claimOrderName 时显示订单号
           SKU 关闭时回退原 m26-record__* 走 address 表单路径。 */
        const app = this.closest("pdlottery-app");
        const skuEnabled = !!(app && app._skuEnabled);
        const isMobile = window.innerWidth <= 768;
        const date =
          typeof dayjs !== "undefined"
            ? dayjs(item.prizeTime).tz("America/New_York").format("MM/DD/YYYY")
            : new Date(item.prizeTime).toLocaleDateString("en-US");

        const prizeImg = item.prizeImg || item.prizeUrl || item.image || "";
        const prizeCode = this._esc(item.activityUserPrizeCode);

        /* ========== status 列 ========== */
        const statusParts = [];

        if (item.claimStatusDesc) {
          statusParts.push(`<p>${this._esc(item.claimStatusDesc)}</p>`);
        }

        /* variant 子块：仅 SKU 模式 + 实物奖品 */
        if (skuEnabled && item.prizeType === 1) {
          const canEdit =
            (item.needSelectVariant || item.multiVariant) &&
            Number(item.claimStatus) === 10;
          if (item.claimVariantTitle) {
            const editBtn = canEdit
              ? `<button type="button" class="pdlottery-record__edit" data-record-action="edit" data-prize-code="${prizeCode}">${this._esc(i18n.edit)}</button>`
              : "";
            statusParts.push(
              `<div class="pdlottery-record__variant"><span>${this._esc(item.claimVariantTitle)}</span>${editBtn}</div>`,
            );
          } else if (canEdit) {
            statusParts.push(
              `<div class="pdlottery-record__variant"><button type="button" class="pdlottery-record__edit" data-record-action="edit" data-prize-code="${prizeCode}">${this._esc(i18n.edit)}</button></div>`,
            );
          }
        }

        /* 订单号 */
        if (
          item.prizeType === 1 &&
          Number(item.claimStatus) === 20 &&
          item.claimOrderName
        ) {
          statusParts.push(
            `<p class="pdlottery-record__order-name">Order: ${this._esc(item.claimOrderName)}</p>`,
          );
        }

        let statusHtml;
        if (statusParts.length > 0) {
          statusHtml = statusParts.join("");
        } else if (!isMobile) {
          statusHtml = `<p>-</p>`;
        } else {
          statusHtml = "";
        }

        /* ========== ops 列 ========== */
        let opsHtml = "-";

        if (item.prizeType === 10) {
          const link = item.extraInfo;
          if (link) {
            opsHtml = `<a class="pdlottery-record__action" href="${this._esc(link)}" target="_blank" rel="noopener noreferrer">${this._esc(link)}</a>`;
          } else {
            const txt =
              item.sendPrizeStatus === 1 ? i18n.claimed : i18n.claiming;
            opsHtml = `<span class="pdlottery-record__action is-disabled">${this._esc(txt)}</span>`;
          }
        } else if (item.prizeType !== 1) {
          /* 优惠券 / 礼品卡 */
          if (item.couponCode && [3, 5, 7].includes(item.prizeType)) {
            const code = item.couponCode || item.extraInfo;
            const codeText = (i18n.code_tip || "__CODE__").replace(
              "__CODE__",
              this._esc(code),
            );
            opsHtml =
              `<button type="button" class="pdlottery-record__copy" data-copy="${this._esc(code)}">` +
              `<span class="pdlottery-record__copy-text">${codeText}</span>` +
              `<span class="pdlottery-record__copy-done" hidden>${this._esc(i18n.copied)}</span>` +
              `</button>`;
          } else {
            const txt =
              item.sendPrizeStatus === 1 ? i18n.claimed : i18n.claiming;
            opsHtml = `<span class="pdlottery-record__action is-disabled">${this._esc(txt)}</span>`;
          }
        } else {
          /* 实物奖品 prizeType=1 */
          if (skuEnabled) {
            const claimStatus = Number(item.claimStatus);
            if (claimStatus === 10) {
              opsHtml = `<button type="button" class="pdlottery-record__action" data-record-action="claim" data-prize-code="${prizeCode}">${this._esc(i18n.claim)}</button>`;
            } else if (claimStatus === 20) {
              opsHtml = `<span class="pdlottery-record__action is-disabled">${this._esc(i18n.claimed)}</span>`;
            } else if (claimStatus === 30) {
              opsHtml = `<button type="button" class="pdlottery-record__action" data-record-action="contact" data-prize-code="${prizeCode}">${this._esc(i18n.contactMomomcozy)}</button>`;
            } else {
              opsHtml = `<button type="button" class="pdlottery-record__action" data-record-action="claim" data-prize-code="${prizeCode}">${this._esc(i18n.claim)}</button>`;
            }
          } else if (item.address) {
            /* 非 SKU：保留原 address 显示逻辑 */
            let addrObj = null;
            try {
              addrObj = JSON.parse(item.address);
            } catch (_) {}
            const src = addrObj && typeof addrObj === "object" ? addrObj : item;
            const parts = [
              src.firstName,
              src.lastName,
              src.phone,
              src.address1,
              src.city,
            ].filter(Boolean);
            opsHtml = `<span class="pdlottery-record__action is-disabled">${this._esc(parts.join(" "))}</span>`;
          } else {
            opsHtml = `<button type="button" class="pdlottery-record__action" data-prize-code="${prizeCode}">${this._esc(i18n.address_btn)}</button>`;
          }
        }

        const mediaHtml = prizeImg
          ? `<img class="pdlottery-record__img" src="${this._esc(prizeImg)}" alt="${this._esc(item.prizeName)}" loading="lazy">`
          : `<span class="pdlottery-record__icon">${this._getPrizeIcon(item.prizeType)}</span>`;

        return (
          '<li class="pdlottery-record__item">' +
          `<div class="pdlottery-record__media">${mediaHtml}</div>` +
          `<div class="pdlottery-record__info">` +
          `<h3 class="pdlottery-record__name">${this._esc(item.prizeName)}</h3>` +
          (date ? `<p class="pdlottery-record__date">${date}</p>` : "") +
          `</div>` +
          `<div class="pdlottery-record__status">${statusHtml}</div>` +
          `<div class="pdlottery-record__ops">${opsHtml}</div>` +
          "</li>"
        );
      }

      /* 与 PdlotteryRecordModal._getPrizeIcon 等价的 SVG fallback。
         仅在奖品无 prizeImg 时使用，绝大多数奖品会从后端拿到真实图片。 */
      _getPrizeIcon(type) {
        /* CozyCoins */
        if (type === 2) {
          return '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M13.5 3.3335C13.5 3.27622 13.4654 3.14179 13.2188 2.94743C12.9777 2.75758 12.5982 2.56458 12.0846 2.39339C11.0623 2.05262 9.61807 1.8335 8 1.8335C6.38193 1.8335 4.93769 2.05262 3.91536 2.39339C3.40181 2.56458 3.02225 2.75758 2.78125 2.94743C2.53462 3.14179 2.5 3.27622 2.5 3.3335C2.5 3.39077 2.53462 3.5252 2.78125 3.71956C3.02225 3.90941 3.40181 4.10241 3.91536 4.2736C4.93769 4.61438 6.38193 4.8335 8 4.8335C9.61807 4.8335 11.0623 4.61438 12.0846 4.2736C12.5982 4.10241 12.9777 3.90941 13.2188 3.71956C13.4654 3.5252 13.5 3.39077 13.5 3.3335ZM14.5 3.3335C14.5 3.8285 14.1985 4.22053 13.8379 4.50472C13.4717 4.79329 12.9729 5.03152 12.401 5.22217C11.2518 5.60525 9.69564 5.8335 8 5.8335C6.30436 5.8335 4.74821 5.60525 3.59896 5.22217C3.02708 5.03152 2.5283 4.79329 2.16211 4.50472C1.80151 4.22053 1.5 3.8285 1.5 3.3335C1.5 2.83849 1.80151 2.44646 2.16211 2.16227C2.5283 1.8737 3.02708 1.63547 3.59896 1.44482C4.74821 1.06174 6.30436 0.833496 8 0.833496C9.69564 0.833496 11.2518 1.06174 12.401 1.44482C12.9729 1.63547 13.4717 1.8737 13.8379 2.16227C14.1985 2.44646 14.5 2.83849 14.5 3.3335Z" fill="black"/><path d="M1.5 12.6668V3.3335C1.5 3.05735 1.72386 2.8335 2 2.8335C2.27614 2.8335 2.5 3.05735 2.5 3.3335V12.6668C2.5 12.7183 2.53044 12.8495 2.77018 13.0425C3.00539 13.2318 3.38364 13.4297 3.91536 13.6069C4.97554 13.9603 6.44529 14.1668 8 14.1668C9.55471 14.1668 11.0245 13.9603 12.0846 13.6069C12.6164 13.4297 12.9946 13.2318 13.2298 13.0425C13.4696 12.8495 13.5 12.7183 13.5 12.6668V3.3335C13.5 3.05735 13.7239 2.8335 14 2.8335C14.2761 2.8335 14.5 3.05735 14.5 3.3335V12.6668C14.5 13.1458 14.2143 13.534 13.8568 13.8218C13.4947 14.1132 12.9944 14.3577 12.401 14.5555C11.2108 14.9523 9.62789 15.1668 8 15.1668C6.37211 15.1668 4.78922 14.9523 3.59896 14.5555C3.00558 14.3577 2.50535 14.1132 2.14323 13.8218C1.78568 13.534 1.5 13.1458 1.5 12.6668Z" fill="black"/><path d="M1.5 8C1.5 7.72386 1.72386 7.5 2 7.5C2.27614 7.5 2.5 7.72386 2.5 8C2.5 8.0515 2.53044 8.18269 2.77018 8.37565C3.00539 8.56493 3.38364 8.76286 3.91536 8.9401C4.97554 9.2935 6.44529 9.5 8 9.5C9.55471 9.5 11.0245 9.2935 12.0846 8.9401C12.6164 8.76286 12.9946 8.56493 13.2298 8.37565C13.4696 8.18269 13.5 8.0515 13.5 8C13.5 7.72386 13.7239 7.5 14 7.5C14.2761 7.5 14.5 7.72386 14.5 8C14.5 8.47893 14.2143 8.86722 13.8568 9.15495C13.4947 9.44636 12.9944 9.69086 12.401 9.88867C11.2108 10.2854 9.62789 10.5 8 10.5C6.37211 10.5 4.78922 10.2854 3.59896 9.88867C3.00558 9.69086 2.50535 9.44636 2.14323 9.15495C1.78568 8.86722 1.5 8.47893 1.5 8Z" fill="black"/></svg>';
        }
        /* 礼品卡 / 优惠券 */
        if (type === 3 || type === 5) {
          return '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M1.3335 3.54166C1.3335 3.05841 1.72525 2.66666 2.2085 2.66666H13.7918C14.2751 2.66666 14.6668 3.05841 14.6668 3.54166V12.4583C14.6668 12.9416 14.2751 13.3333 13.7918 13.3333H2.2085C1.72525 13.3333 1.3335 12.9416 1.3335 12.4583V3.54166Z" stroke="black" stroke-width="1.5"/></svg>';
        }
        /* 默认：包裹图标 */
        return '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 5L8 1L14 5V13H2V5Z" stroke="black" stroke-width="1.5" stroke-linejoin="round"/><path d="M6 13V8.5H10V13" stroke="black" stroke-width="1.5" stroke-linejoin="round"/></svg>';
      }
      _bindCopy(container) {
        container.querySelectorAll("[data-copy]").forEach(function (btn) {
          btn.addEventListener(
            "click",
            function () {
              /* modal 内操作前再次校验 cookie，防止已退出登录 */
              pdSyncM26AuthFromCookie();
              const auth = pdGetM26Auth();
              if (!auth || !auth.user) {
                if (this._modal) this._modal.close();
                pdLoginForEl(this);
                return;
              }
              navigator.clipboard
                .writeText(btn.dataset.copy)
                .catch(function () {});
              const text = btn.querySelector(".pdlottery-record__copy-text");
              const done = btn.querySelector(".pdlottery-record__copy-done");
              if (text) text.hidden = true;
              if (done) done.hidden = false;
              setTimeout(function () {
                if (text) text.hidden = false;
                if (done) done.hidden = true;
              }, 2000);
            }.bind(this),
          );
        }, this);
        container.querySelectorAll("[data-prize-code]").forEach(function (btn) {
          btn.addEventListener(
            "click",
            function () {
              /* modal 内操作前再次校验 cookie，防止已退出登录 */
              pdSyncM26AuthFromCookie();
              const auth = pdGetM26Auth();
              if (!auth || !auth.user) {
                if (this._modal) this._modal.close();
                pdLoginForEl(this);
                return;
              }
              const recordAction = btn.dataset.recordAction;
              /* 多 SKU 开关开启时按 data-record-action 分流：
                 open-sku / edit → 唤起 pd-sku 弹框（兼容旧"Select Variant"按钮与新"Edit"按钮）
                 claim → queryClaimParams + 跳转
                 contact → 关闭 record modal 后唤起 Zendesk
                 开关关闭时（recordAction 为空）保持原 address 表单流程。 */
              if (recordAction === "open-sku" || recordAction === "edit") {
                this._handleRecordOpenSku(btn);
                return;
              }
              if (recordAction === "claim") {
                this._handleRecordClaim(btn);
                return;
              }
              if (recordAction === "contact") {
                this._handleRecordContact(btn);
                return;
              }
              const prev = document.body.querySelector("m26-address-select");
              if (prev) prev.remove();
              const el = document.createElement("m26-address-select");
              el.dataset.prizeCode = btn.dataset.prizeCode;
              document.body.appendChild(el);
              document.addEventListener(
                "m26:address-saved",
                function () {
                  this._loadRecords();
                }.bind(this),
                { once: true },
              );
            }.bind(this),
          );
        }, this);
      }

      /* ── 多 SKU 开关开启时的中奖记录按钮 handler ──
       * 仅在 skuEnabled=true 时被触发（_bindCopy 已按 data-record-action 分流）。
       * 与 PdlotteryRecordModal 的同名方法实现等价，供 M26RecordPanelLocal 使用。 */
      _getLotteryForRecord() {
        /* 从全局 _fetchHelper 或 _lottery 拿取，若不可用则构造一个最小的 _fetch 工具 */
        return (
          (this.closest("pdlottery-app") &&
            this.closest("pdlottery-app")._lottery) ||
          window._lotteryFetch || {
            _fetch: function (path, opts) {
              return m26FetchLocal(path, opts || {});
            },
          }
        );
      }
      _handleRecordOpenSku(button) {
        var self = this;
        var prizeCode = button.dataset.prizeCode || "";
        var item = self._recordsByCode && self._recordsByCode[prizeCode];
        if (!item) {
          if (m26ApiErrorTipLocal)
            m26ApiErrorTipLocal(new Error("Record item not found"));
          return;
        }
        /* 隐藏当前 record modal 的可见内容（保留 modal 关闭时的内部状态：
           _isOpen=true、_bodyEl、按钮事件监听器、_bodyHtml 等），这样 SKU 弹框
           关闭后可直接 _restoreRecordModalAfterSku 恢复，且不会丢监听器 / 旧数据。
           _modal.close() 会真正销毁并清空 _bodyHtml，会造成"再次打开看到旧数据 / 空白"。
           遮罩（_overlayEl）保持显示，用户体验上仍然"处于 record modal 上下文"。 */
        self._hideRecordModalForSku();
        var app = self.closest("pdlottery-app");
        var actType =
          (app && app._activityType) || window.__MC_ACTIVITY_TYPE__ || "";
        /* 与 PdlotteryRecordModal._handleRecordOpenSku / PdlotteryApp._openSkuDialog
         * 三处保持 prize / i18n / source / trigger / background 字段一致。 */
        document.dispatchEvent(
          new CustomEvent("pd-sku:open", {
            detail: {
              prize: {
                productId: item.claimProductId || item.productId || "",
                productHandle: item.productHandle || item.handle || "",
                name: item.prizeName || item.name || "",
                image: item.prizeImg || item.prizeUrl || item.image || "",
                activityUserPrizeCode:
                  item.activityUserPrizeCode || item.prizeCode || prizeCode,
                activityType: actType,
                prizeType: 1,
                claimVariantId: item.claimVariantId || "",
                closeOnSuccess: true,
              },
              i18n: m26I18nLocal && m26I18nLocal.get("win"),
              source: "m26-record-panel",
              background: "transparent",
              trigger: button || null,
              disappeared:true
            },
          }),
        );
        /* 监听 pd-sku:close：SKU 弹框关闭（任意路径：× / 遮罩 / ESC / Confirm cancel）
           后恢复 record modal 显示——只取消视觉隐藏，不再重拉接口 / 重建 DOM。 */
        if (self._skuCloseHandler) {
          document.removeEventListener("pd-sku:close", self._skuCloseHandler);
        }
        self._skuCloseHandler = function _onSkuCloseRecord() {
          /* 仅恢复 modal 显示，保留之前的数据与事件监听器，避免再次打开看到旧 / 空数据 */
          self._restoreRecordModalAfterSku();
          document.removeEventListener("pd-sku:close", self._skuCloseHandler);
          self._skuCloseHandler = null;
        };
        document.addEventListener("pd-sku:close", self._skuCloseHandler);
      }

      /* 把当前 record modal 的 box 视觉上隐藏（保留 _isOpen=true、_bodyEl、按钮监听器
         与 _bodyHtml），用于在 SKU 弹框打开期间让出可视区但不丢状态。
         遮罩（_overlayEl）保留显示，用户体验上仍处于 record modal 上下文。 */
      _hideRecordModalForSku() {
        if (!this._modal || !this._modal._boxEl) return;
        const box = this._modal._boxEl;
        box.classList.add("pdl-modal-hidden-by-sku");
        box.setAttribute("data-pdl-hidden-by-sku", "1");
        box.setAttribute("aria-hidden", "true");
      }

      /* SKU 弹框关闭后恢复 record modal。仅在确实处于被 SKU 隐藏状态时恢复，
         避免误操作恢复已被业务 close 的 modal。 */
      _restoreRecordModalAfterSku() {
        if (!this._modal || !this._modal._boxEl) return;
        const box = this._modal._boxEl;
        if (box.getAttribute("data-pdl-hidden-by-sku") !== "1") return;
        box.classList.remove("pdl-modal-hidden-by-sku");
        box.removeAttribute("data-pdl-hidden-by-sku");
        box.removeAttribute("aria-hidden");
      }

      _handleRecordClaim(button) {
        var self = this;
        var prizeCode = button.dataset.prizeCode || "";
        button.disabled = true;
        button.classList.add("is-loading");
        button.setAttribute("aria-busy", "true");
        var app = self.closest("pdlottery-app");
        var actType =
          (app && app._activityType) || window.__MC_ACTIVITY_TYPE__ || "";
        var item = self._recordsByCode && self._recordsByCode[prizeCode];
        /* 与 M26WinPopup._handleClaim 一致：GET 请求，参数放 URL：
           activityType + activityUserPrizeCode + (claimVariantId 可选)。
           不再 POST + body，与中奖弹框实物奖品领取传参完全对齐。 */
        var qs =
          "?activityType=" +
          encodeURIComponent(actType) +
          "&activityUserPrizeCode=" +
          encodeURIComponent(prizeCode);
        if (item && item.claimVariantId) {
          qs +=
            "&claimVariantId=" +
            encodeURIComponent(String(item.claimVariantId));
        }
        var path = "/api/station/activity/raffle/queryClaimParams" + qs;
        var lottery = self._getLotteryForRecord();
        lottery
          ._fetch(path)
          .then(function (res) {
            var checkoutUrl =
              res &&
              (res.checkoutUrl ||
                res.url ||
                (res.data && res.data.checkoutUrl));
            if (checkoutUrl) {
              if (self._modal) self._modal.close();
              window.location.href = checkoutUrl;
            } else if (m26ApiErrorTipLocal) {
              m26ApiErrorTipLocal(res || new Error("No checkoutUrl"));
            }
          })
          .catch(function (err) {
            if (m26ApiErrorTipLocal) m26ApiErrorTipLocal(err);
          })
          .finally(function () {
            button.classList.remove("is-loading");
            button.disabled = false;
            button.removeAttribute("aria-busy");
          });
      }

      /* 联系客服（claimStatus=30 失败时）
       *
       * 参考 autumn _handleRecordAction 中 action === "contact" 的实现：
       *   - 提高 Zendesk launcher z-index（autumn 用 1999，是 magic 值；
       *     实际 Zendesk Web Widget 弹窗用 iframe/shadow DOM 能突破页面 z-index）
       *   - 调用 window.zE("messenger", "open") 唤起 Zendesk
       *
       * PD 在此基础上额外关闭 record modal（autumn 没关闭）：
       *   - record modal 的遮罩是 position: fixed; z-index: 999 / box 100000
       *   - 即使 Zendesk widget 能突破，也存在被遮罩遮挡的边角风险（特别是 launcher）
       *   - 先关 modal 是最稳的方案，避免任何遮挡
       *
       * Fallback：当 Zendesk 未加载（window.zE 不可用）时，跳转到 mailto 链接
       * （autumn 没提供 fallback，PD 在这层兜底，保证用户始终能找到客服）。 */
      _handleRecordContact(button) {
        /* 关闭 record modal，避免遮罩遮挡 Zendesk 弹框 */
        if (this._modal) this._modal.close();
        /* autumn 等价：把 Zendesk launcher z-index 提到 1999（autumn magic 值） */
        try {
          var launcher = document.querySelector("#launcher");
          if (launcher) launcher.style.zIndex = "100000";
        } catch (_) {}
        /* 优先 Zendesk messenger */
        if (typeof window.zE === "function") {
          try {
            window.zE("messenger", "open");
            return;
          } catch (_) {
            /* fall through to mailto fallback */
          }
        }
        /* Fallback：跳转到 mailto / 客服链接（i18n.contactMomomcozy 可被运营覆盖为完整 URL） */
        var href =
          (this._recordsByCode &&
            this._recordsByCode[button.dataset.prizeCode || ""] &&
            this._recordsByCode[button.dataset.prizeCode || ""].contactUrl) ||
          window.__MC_CONTACT_HREF__ ||
          "mailto:support@momcozy.com";
        try {
          window.open(href, "_blank", "noopener,noreferrer");
        } catch (_) {
          window.location.href = href;
        }
      }
    }
    customElements.define("m26-record-panel", M26RecordPanelLocal);
  }

  /* ── PdlotteryRecordModal 自定义元素 ─────────────────────────────────
   * 合并「获奖记录」与「规则」两个弹框为一个带 Tab 切换的面板
   * data-default-tab="records" | "rules"
   * ─────────────────────────────────────────────────────────────────── */
  if (!customElements.get("pdlottery-record-modal")) {
    class PdlotteryRecordModal extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        this._modal = null;
        this._defaultTab = this.dataset.defaultTab || "records";
        this.addEventListener("click", this);
      }

      disconnectedCallback() {
        this.removeEventListener("click", this);
        if (this._modal) {
          this._modal.destroy();
          this._modal = null;
        }
      }

      handleEvent(e) {
        if (e.type !== "click") return;
        /* 点击 modal 内部 Tab 不触发重新打开 */
        if (e.target.closest(".m26-modal-overlay")) return;
        this._openModal(this._defaultTab);
      }

      /* 查找 section 的 rules_content（从模板 slot 或最近的 pdlottery-app 取） */
      _getRulesContent() {
        const tpl = this.querySelector("template");
        if (tpl) {
          const rulesEl = tpl.content.querySelector(
            ".pdlottery-modal__rules-content",
          );
          if (rulesEl) return rulesEl.innerHTML;
        }
        /* 回退：查找同一 section 内最近的 rules content */
        const app = this.closest("pdlottery-app");
        if (app) {
          const rc = app.querySelector(".pdlottery-modal__rules-content");
          if (rc) return rc.innerHTML;
        }
        return "";
      }

      /* 找到对应的 pdlottery-app 实例 */
      _getApp() {
        return this.closest("pdlottery-app");
      }

      async _openModal(activeTab) {
        /* 首次创建弹框结构 */
        if (!this._modal) {
          this._modal = new M26ModalLocal("pdlottery-modal");
        }
        const rulesHtml = this._getRulesContent();
        const modalHtml = this._buildModalHtml(activeTab, rulesHtml);
        this._modal.setContent(modalHtml);
        this._modal.show();
        const app = this._getApp();
        const bg = pdGetSelectedCodeBg(app);
        const box =
          (this._modal && this._modal._boxEl) ||
          document.querySelector(".m26-modal-box.pdlottery-modal.is-open");
        pdSetSelectedCodeBgVars(box, bg.pc, bg.mobile);
        pdEnhanceDialogA11y(box);

        /* 绑定 Tab 切换 */
        this._bindTabs();

        /* 若初始 tab 是 records，加载记录 */
        if (activeTab === "records") {
          await this._loadRecords();
        }
      }

      _buildModalHtml(activeTab, rulesHtml) {
        const recordActive = activeTab === "records" ? "is-active" : "";
        const rulesActive = activeTab === "rules" ? "is-active" : "";
        const recordSelected = activeTab === "records" ? "true" : "false";
        const rulesSelected = activeTab === "rules" ? "true" : "false";
        return `
          <div class="pdlottery-modal">
            <div class="pdlottery-modal__header">
              <h2 class="pdlottery-modal__title" id="pdlottery-modal-title">Rules &amp; Prize Records</h2>
            </div>
            <div class="pdlottery-modal__tabs" role="tablist" aria-label="Prize Records and Rules">
              <button type="button" role="tab" aria-selected="${recordSelected}" aria-controls="pdlottery-pane-records" id="pdlottery-tab-records" class="pdlottery-modal__tab ${recordActive}" data-pdlottery-tab="records">Prize Records</button>
              <button type="button" role="tab" aria-selected="${rulesSelected}"  aria-controls="pdlottery-pane-rules"   id="pdlottery-tab-rules"    class="pdlottery-modal__tab ${rulesActive}"   data-pdlottery-tab="rules">Rules</button>
            </div>
            <div class="pdlottery-modal__body">
              <div role="tabpanel" id="pdlottery-pane-rules" aria-labelledby="pdlottery-tab-rules" class="pdlottery-modal__pane pdlottery-modal__pane--rules ${rulesActive}" data-pdlottery-pane="rules">
                <div class="pdlottery-modal__rules-body">${rulesHtml || ""}</div>
              </div>
              <div role="tabpanel" id="pdlottery-pane-records" aria-labelledby="pdlottery-tab-records" class="pdlottery-modal__pane pdlottery-modal__pane--records ${recordActive}" data-pdlottery-pane="records">
                <div class="pdlottery-modal__records-loading" aria-live="polite">
                  ${Array.from({ length: 3 })
                    .map(
                      () =>
                        '<div class="pdlottery-modal__skeleton-item"><span class="pdlottery-modal__skeleton pdlottery-modal__skeleton-img"></span><div class="pdlottery-modal__skeleton-info"><span class="pdlottery-modal__skeleton pdlottery-modal__skeleton-name"></span><span class="pdlottery-modal__skeleton pdlottery-modal__skeleton-date"></span></div><span class="pdlottery-modal__skeleton pdlottery-modal__skeleton-action"></span></div>',
                    )
                    .join("")}
                </div>
                <div class="pdlottery-modal__records-empty" hidden>
                  <svg xmlns="http://www.w3.org/2000/svg" width="104" height="104" viewBox="0 0 104 104" fill="none" aria-hidden="true" focusable="false">
  <path opacity="0.5" d="M2 90C2 91.1935 7.26784 92.3381 16.6447 93.182C26.0215 94.0259 38.7392 94.5 52 94.5C65.2608 94.5 77.9785 94.0259 87.3553 93.182C96.7322 92.3381 102 91.1935 102 90C102 88.8065 96.7322 87.6619 87.3553 86.818C77.9785 85.9741 65.2608 85.5 52 85.5C38.7392 85.5 26.0215 85.9741 16.6447 86.818C7.26784 87.6619 2 88.8065 2 90Z" fill="#E6E6E6"/>
  <path d="M88 63.5H66.4L59.2 74.5H44.8L37.6 63.5H16" stroke="#B3B3B3" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M22.7254 44.6913L14 64.5V81.75C14 83.275 14.8007 84.7375 16.226 85.8159C17.6513 86.8942 19.5844 87.5 21.6 87.5H82.4C84.4156 87.5 86.3487 86.8942 87.774 85.8159C89.1993 84.7375 90 83.275 90 81.75V64.5L81.2746 44.6913C80.6454 43.7333 79.6755 42.9271 78.4738 42.3633C77.2722 41.7995 75.8865 41.5006 74.4726 41.5H29.5274C28.1135 41.5006 26.7278 41.7995 25.5262 42.3633C24.3245 42.9271 23.3546 43.7333 22.7254 44.6913Z" stroke="#B3B3B3" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M26 30.5L20 19.5" stroke="#B3B3B3" stroke-width="4" stroke-linecap="round"/>
  <path d="M78 30.5L84 19.5" stroke="#B3B3B3" stroke-width="4" stroke-linecap="round"/>
  <path d="M52 29.5V9.5" stroke="#B3B3B3" stroke-width="4" stroke-linecap="round"/>
</svg>
                  <p class="pdlottery-modal__empty-text">No available data</p>
                </div>
                <ul class="pdlottery-modal__records-list" hidden></ul>
              </div>
            </div>
          </div>`;
      }

      _bindTabs() {
        const body = this._modal && this._modal._bodyEl;
        if (!body) return;
        const tabs = [...body.querySelectorAll("[data-pdlottery-tab]")];

        const activateTab = async (btn) => {
          const tab = btn.dataset.pdlotteryTab;
          tabs.forEach((b) => {
            const active = b === btn;
            b.classList.toggle("is-active", active);
            b.setAttribute("aria-selected", active ? "true" : "false");
            b.setAttribute("tabindex", active ? "0" : "-1");
          });
          body
            .querySelectorAll("[data-pdlottery-pane]")
            .forEach((p) =>
              p.classList.toggle("is-active", p.dataset.pdlotteryPane === tab),
            );
          if (tab === "records") await this._loadRecords();
        };

        tabs.forEach((btn, i) => {
          btn.setAttribute(
            "tabindex",
            btn.classList.contains("is-active") ? "0" : "-1",
          );
          btn.addEventListener("click", () => activateTab(btn));
          btn.addEventListener("keydown", (e) => {
            if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
              e.preventDefault();
              const next =
                tabs[
                  (i + (e.key === "ArrowRight" ? 1 : -1) + tabs.length) %
                    tabs.length
                ];
              next.focus();
              activateTab(next);
            }
          });
        });
      }

      /* 获取 activityType */
      _getActivityType() {
        const app = this._getApp();
        if (app) return app._activityType || "";
        return window.__MC_ACTIVITY_TYPE__ || "";
      }

      async _loadRecords() {
        const body = this._modal && this._modal._bodyEl;
        if (!body) return;

        const loadingEl = body.querySelector(
          ".pdlottery-modal__records-loading",
        );
        const emptyEl = body.querySelector(".pdlottery-modal__records-empty");
        const listEl = body.querySelector(".pdlottery-modal__records-list");
        if (!emptyEl || !listEl) return;

        pdSyncM26AuthFromCookie();
        const auth = pdGetM26Auth();

        /* 未登录时直接展示空态（同时关掉骨架屏） */
        if (!auth || !auth.user) {
          if (loadingEl) loadingEl.hidden = true;
          emptyEl.hidden = false;
          listEl.hidden = true;
          return;
        }

        /* 进入加载态：骨架屏显示，列表 / 空态隐藏。
           _openModal 首次进入 / Tab 切换进入 records 时立即可见，避免出现"白屏 → 内容" 的闪烁。 */
        if (loadingEl) loadingEl.hidden = false;
        emptyEl.hidden = true;
        listEl.hidden = true;
        const pane = body.querySelector("[data-pdlottery-pane='records']");
        if (pane) pane.setAttribute("aria-busy", "true");

        try {
          const actType = this._getActivityType();
          const app = this._getApp();
          const skuEnabled = !!(app && app._skuEnabled);
          const qs =
            "activityType=" +
            encodeURIComponent(actType) +
            (skuEnabled ? "&newRaffleFlow=true" : "");
          const endpoint = skuEnabled
            ? "/api/station/activity/raffle/queryShopWinningRecord"
            : "/api/station/activity/raffle/queryWinningRecord";
          const res = await m26FetchLocal(`${endpoint}?${qs}`);
          const beans = res && res.recordBeans;
          let items = [];
          if (Array.isArray(beans)) {
            items = beans;
          } else if (beans && typeof beans === "object") {
            Object.keys(beans).forEach((k) => {
              const v = beans[k];
              items = items.concat(Array.isArray(v) ? v : [v]);
            });
          }

          if (loadingEl) loadingEl.hidden = true;
          if (pane) pane.removeAttribute("aria-busy");

          if (!items.length) {
            emptyEl.hidden = false;
            listEl.hidden = true;
            return;
          }

          emptyEl.hidden = true;
          listEl.hidden = false;
          /* 按 activityUserPrizeCode 缓存 record item，供 _handleRecordOpenSku
             读取 productId / productHandle / prizeName 等字段。 */
          this._recordsByCode = {};
          items.forEach((it) => {
            if (it && it.activityUserPrizeCode)
              this._recordsByCode[it.activityUserPrizeCode] = it;
          });
          listEl.innerHTML = items
            .map((item, idx) => this._renderRecordItem(item, idx))
            .join("");
          this._bindRecordActions(listEl);
        } catch (_) {
          if (loadingEl) loadingEl.hidden = true;
          if (pane) pane.removeAttribute("aria-busy");
          emptyEl.hidden = false;
          listEl.hidden = true;
        }
      }

      _esc(str) {
        return str == null ? "" : String(str);
      }

      _renderRecordItem(item, index) {
        /* 与 autumn _renderRecordItem 对齐：4 列网格（media / info / status+variant / ops）。
           SKU 开启时额外渲染 variant 子块（claimVariantTitle + Edit）和 订单号（claimOrderName）。
           单 SKU 模式回退到 m26-address-select 旧流程。 */
        const isMobile = window.innerWidth <= 768;

        /* 日期格式化 */
        const date =
          typeof dayjs !== "undefined"
            ? dayjs(item.prizeTime).tz("America/New_York").format("YYYY/MM/DD")
            : new Date(item.prizeTime)
                .toLocaleDateString("en-CA")
                .replace(/-/g, "/");

        /* 奖品图（real image，与 autumn 对齐；无图则回退 SVG 图标以兼容无图奖品） */
        const prizeImg = item.prizeImg || item.prizeUrl || item.image || "";

        const recordI18n = m26I18nLocal.get("record") || {};

        /* ========== status 列（含 variant 子块 / 订单号） ========== */
        const statusParts = [];

        if (item.claimStatusDesc) {
          statusParts.push(`<p>${this._esc(item.claimStatusDesc)}</p>`);
        }

        /* variant 子块：仅 SKU 模式 + 实物奖品（prizeType=1）显示
           - 已有 claimVariantTitle：显示 title + (canEdit 时) Edit 按钮
           - 未选过但 canEdit：仅显示 Edit 按钮（autumn 同款空变体块） */
        if (this._skuEnabled && item.prizeType === 1) {
          const canEdit =
            (item.needSelectVariant || item.multiVariant) &&
            Number(item.claimStatus) === 10;
          if (item.claimVariantTitle) {
            const editBtn = canEdit
              ? `<button type="button" class="pdlottery-record__edit" data-record-action="edit" data-prize-code="${this._esc(item.activityUserPrizeCode)}">${this._esc(recordI18n.edit || "Edit")}</button>`
              : "";
            statusParts.push(
              `<div class="pdlottery-record__variant"><span>${this._esc(item.claimVariantTitle)}</span>${editBtn}</div>`,
            );
          } else if (canEdit) {
            statusParts.push(
              `<div class="pdlottery-record__variant"><button type="button" class="pdlottery-record__edit" data-record-action="edit" data-prize-code="${this._esc(item.activityUserPrizeCode)}">${this._esc(recordI18n.edit || "Edit")}</button></div>`,
            );
          }
        }

        /* 订单号：实物奖品 + claimStatus=20 + 已有 claimOrderName */
        if (
          item.prizeType === 1 &&
          Number(item.claimStatus) === 20 &&
          item.claimOrderName
        ) {
          statusParts.push(
            `<p class="pdlottery-record__order-name">Order: ${this._esc(item.claimOrderName)}</p>`,
          );
        }

        let statusHtml;
        if (statusParts.length > 0) {
          statusHtml = statusParts.join("");
        } else if (!isMobile) {
          statusHtml = `<p>-</p>`;
        } else {
          statusHtml = "";
        }

        /* ========== ops 列（右侧按钮） ========== */
        let opsHtml = "-";
        const prizeCode = this._esc(item.activityUserPrizeCode);

        if (item.prizeType === 1) {
          if (this._skuEnabled) {
            const claimStatus = Number(item.claimStatus);
            if (claimStatus === 10) {
              opsHtml = `<button type="button" class="pdlottery-record__action" data-record-action="claim" data-prize-code="${prizeCode}">${this._esc(recordI18n.claim || "Claim")}</button>`;
            } else if (claimStatus === 20) {
              opsHtml = `<span class="pdlottery-record__action is-disabled">${this._esc(recordI18n.claimed || "Claimed")}</span>`;
            } else if (claimStatus === 30) {
              opsHtml = `<button type="button" class="pdlottery-record__action" data-record-action="contact" data-prize-code="${prizeCode}">${this._esc(recordI18n.contactMomomcozy || "Contact Momcozy")}</button>`;
            } else {
              opsHtml = `<button type="button" class="pdlottery-record__action" data-record-action="claim" data-prize-code="${prizeCode}">${this._esc(recordI18n.claim || "Claim")}</button>`;
            }
          } else if (item.address) {
            opsHtml = `<span class="pdlottery-record__action is-disabled">${this._esc(recordI18n.claimed || "Claimed")}</span>`;
          } else {
            opsHtml = `<button type="button" class="pdlottery-record__action" data-prize-code="${prizeCode}">Fill The Address</button>`;
          }
        } else if (item.prizeType === 2) {
          /* CozyCoins 积分：橙色 +N */
          const coins = item.prizeValue || item.prizeName || "";
          opsHtml = `<span class="pdlottery-record__coins">+${this._esc(coins)}</span>`;
        } else if (item.prizeType === 3 || item.prizeType === 5) {
          /* 优惠券 */
          if (item.couponCode || item.extraInfo) {
            const code = item.couponCode || item.extraInfo;
            opsHtml = `<button type="button" class="pdlottery-record__copy" data-copy="${this._esc(code)}">${this._esc(code)}</button>`;
          } else {
            opsHtml = `<span class="pdlottery-record__action is-disabled">${this._esc(recordI18n.claimed || "")}</span>`;
          }
        } else if (item.prizeType === 10) {
          /* 链接奖品 */
          const link = item.extraInfo;
          if (link) {
            opsHtml = `<a class="pdlottery-record__action" href="${this._esc(link)}" target="_blank" rel="noopener noreferrer">${this._esc(link)}</a>`;
          }
        } else {
          /* 礼品卡等 */
          opsHtml = `<span class="pdlottery-record__action is-disabled">${item.sendPrizeStatus === 1 ? "Received" : "Processing"}</span>`;
        }

        const mediaHtml = prizeImg
          ? `<img class="pdlottery-record__img" src="${this._esc(prizeImg)}" alt="${this._esc(item.prizeName)}" loading="lazy">`
          : `<span class="pdlottery-record__icon">${this._getPrizeIcon(item.prizeType)}</span>`;

        return `
          <li class="pdlottery-record__item">
            <div class="pdlottery-record__media">${mediaHtml}</div>
            <div class="pdlottery-record__info">
              <h3 class="pdlottery-record__name">${this._esc(item.prizeName)}</h3>
              ${date ? `<p class="pdlottery-record__date">${date}</p>` : ""}
            </div>
            <div class="pdlottery-record__status">${statusHtml}</div>
            <div class="pdlottery-record__ops">${opsHtml}</div>
          </li>`;
      }

      _getPrizeIcon(type) {
        /* CozyCoins */
        if (type === 2) {
          return `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M13.5 3.3335C13.5 3.27622 13.4654 3.14179 13.2188 2.94743C12.9777 2.75758 12.5982 2.56458 12.0846 2.39339C11.0623 2.05262 9.61807 1.8335 8 1.8335C6.38193 1.8335 4.93769 2.05262 3.91536 2.39339C3.40181 2.56458 3.02225 2.75758 2.78125 2.94743C2.53462 3.14179 2.5 3.27622 2.5 3.3335C2.5 3.39077 2.53462 3.5252 2.78125 3.71956C3.02225 3.90941 3.40181 4.10241 3.91536 4.2736C4.93769 4.61438 6.38193 4.8335 8 4.8335C9.61807 4.8335 11.0623 4.61438 12.0846 4.2736C12.5982 4.10241 12.9777 3.90941 13.2188 3.71956C13.4654 3.5252 13.5 3.39077 13.5 3.3335ZM14.5 3.3335C14.5 3.8285 14.1985 4.22053 13.8379 4.50472C13.4717 4.79329 12.9729 5.03152 12.401 5.22217C11.2518 5.60525 9.69564 5.8335 8 5.8335C6.30436 5.8335 4.74821 5.60525 3.59896 5.22217C3.02708 5.03152 2.5283 4.79329 2.16211 4.50472C1.80151 4.22053 1.5 3.8285 1.5 3.3335C1.5 2.83849 1.80151 2.44646 2.16211 2.16227C2.5283 1.8737 3.02708 1.63547 3.59896 1.44482C4.74821 1.06174 6.30436 0.833496 8 0.833496C9.69564 0.833496 11.2518 1.06174 12.401 1.44482C12.9729 1.63547 13.4717 1.8737 13.8379 2.16227C14.1985 2.44646 14.5 2.83849 14.5 3.3335Z" fill="black"/>
  <path d="M1.5 12.6668V3.3335C1.5 3.05735 1.72386 2.8335 2 2.8335C2.27614 2.8335 2.5 3.05735 2.5 3.3335V12.6668C2.5 12.7183 2.53044 12.8495 2.77018 13.0425C3.00539 13.2318 3.38364 13.4297 3.91536 13.6069C4.97554 13.9603 6.44529 14.1668 8 14.1668C9.55471 14.1668 11.0245 13.9603 12.0846 13.6069C12.6164 13.4297 12.9946 13.2318 13.2298 13.0425C13.4696 12.8495 13.5 12.7183 13.5 12.6668V3.3335C13.5 3.05735 13.7239 2.8335 14 2.8335C14.2761 2.8335 14.5 3.05735 14.5 3.3335V12.6668C14.5 13.1458 14.2143 13.534 13.8568 13.8218C13.4947 14.1132 12.9944 14.3577 12.401 14.5555C11.2108 14.9523 9.62789 15.1668 8 15.1668C6.37211 15.1668 4.78922 14.9523 3.59896 14.5555C3.00558 14.3577 2.50535 14.1132 2.14323 13.8218C1.78568 13.534 1.5 13.1458 1.5 12.6668Z" fill="black"/>
  <path d="M1.5 8C1.5 7.72386 1.72386 7.5 2 7.5C2.27614 7.5 2.5 7.72386 2.5 8C2.5 8.0515 2.53044 8.18269 2.77018 8.37565C3.00539 8.56493 3.38364 8.76286 3.91536 8.9401C4.97554 9.2935 6.44529 9.5 8 9.5C9.55471 9.5 11.0245 9.2935 12.0846 8.9401C12.6164 8.76286 12.9946 8.56493 13.2298 8.37565C13.4696 8.18269 13.5 8.0515 13.5 8C13.5 7.72386 13.7239 7.5 14 7.5C14.2761 7.5 14.5 7.72386 14.5 8C14.5 8.47893 14.2143 8.86722 13.8568 9.15495C13.4947 9.44636 12.9944 9.69086 12.401 9.88867C11.2108 10.2854 9.62789 10.5 8 10.5C6.37211 10.5 4.78922 10.2854 3.59896 9.88867C3.00558 9.69086 2.50535 9.44636 2.14323 9.15495C1.78568 8.86722 1.5 8.47893 1.5 8Z" fill="black"/>
</svg>`;
        }
        /* 礼品卡 / 优惠券 */
        if (type === 3 || type === 5) {
          return `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M1.3335 3.54166C1.3335 3.05841 1.72525 2.66666 2.2085 2.66666H13.7918C14.2751 2.66666 14.6668 3.05841 14.6668 3.54166V12.4583C14.6668 12.9416 14.2751 13.3333 13.7918 13.3333H2.2085C1.72525 13.3333 1.3335 12.9416 1.3335 12.4583V3.54166Z" stroke="black"/>
  <path d="M1.3335 6.66656H14.4975" stroke="black"/>
  <path d="M10 2.66656L10 13.3332" stroke="black"/>
  <path d="M10.0002 6.66667V5.33333C10.0002 4.59695 9.40321 4 8.66683 4C7.93045 4 7.3335 4.59695 7.3335 5.33333C7.3335 6.06971 7.93045 6.66667 8.66683 6.66667H10.0002Z" stroke="black"/>
  <path d="M9.99984 6.66668V8.00001C9.99984 8.73639 10.5968 9.33334 11.3332 9.33334C12.0696 9.33334 12.6665 8.73639 12.6665 8.00001C12.6665 7.26363 12.0695 6.66668 11.3332 6.66668H9.99984Z" stroke="black"/>
</svg>`;
        }
        /* 实物 / 默认礼盒 */
        return `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M8 4.66669V14" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.3332 7.33331V12.6666C13.3332 13.0203 13.1927 13.3594 12.9426 13.6095C12.6926 13.8595 12.3535 14 11.9998 14H3.99984C3.64622 14 3.30708 13.8595 3.05703 13.6095C2.80698 13.3594 2.6665 13.0203 2.6665 12.6666V7.33331" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5.00016 4.66663C4.55814 4.66663 4.13421 4.49104 3.82165 4.17848C3.50909 3.86592 3.3335 3.44199 3.3335 2.99997C3.3335 2.55794 3.50909 2.13402 3.82165 1.82145C4.13421 1.50889 4.55814 1.3333 5.00016 1.3333C5.64329 1.32209 6.27351 1.63414 6.80865 2.22874C7.34379 2.82334 7.75901 3.6729 8.00016 4.66663C8.24131 3.6729 8.65653 2.82334 9.19167 2.22874C9.72681 1.63414 10.357 1.32209 11.0002 1.3333C11.4422 1.3333 11.8661 1.50889 12.1787 1.82145C12.4912 2.13402 12.6668 2.55794 12.6668 2.99997C12.6668 3.44199 12.4912 3.86592 12.1787 4.17848C11.8661 4.49104 11.4422 4.66663 11.0002 4.66663" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.3333 4.66669H2.66667C2.29848 4.66669 2 4.96516 2 5.33335V6.66669C2 7.03488 2.29848 7.33335 2.66667 7.33335H13.3333C13.7015 7.33335 14 7.03488 14 6.66669V5.33335C14 4.96516 13.7015 4.66669 13.3333 4.66669Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
      }

      _bindRecordActions(container) {
        /* 复制优惠码 */
        container.querySelectorAll("[data-copy]").forEach((btn) => {
          btn.addEventListener("click", () => {
            /* modal 内操作前再次校验 cookie，防止已退出登录 */
            pdSyncM26AuthFromCookie();
            const auth = pdGetM26Auth();
            if (!auth || !auth.user) {
              if (this._modal) this._modal.close();
              pdLoginForEl(this);
              return;
            }
            navigator.clipboard.writeText(btn.dataset.copy).catch(() => {});
            const orig = btn.textContent;
            btn.textContent = "Copied!";
            setTimeout(() => {
              btn.textContent = orig;
            }, 2000);
          });
        });
        /* 填写地址 / 多 SKU 弹框分发 */
        container.querySelectorAll("[data-prize-code]").forEach((btn) => {
          btn.addEventListener("click", () => {
            /* modal 内操作前再次校验 cookie，防止已退出登录 */
            pdSyncM26AuthFromCookie();
            const auth = pdGetM26Auth();
            if (!auth || !auth.user) {
              if (this._modal) this._modal.close();
              pdLoginForEl(this);
              return;
            }
            const action = btn.dataset.recordAction;
            if (action === "open-sku" || action === "edit") {
              /* open-sku: 旧"Select Variant"按钮（兼容旧模板）
                 edit: 新"Edit"按钮（与 autumn 对齐，claimStatus=10 + needSelectVariant） */
              this._handleRecordOpenSku(btn);
              return;
            }
            if (action === "claim") {
              this._handleRecordClaim(btn);
              return;
            }
            if (action === "contact") {
              this._handleRecordContact(btn);
              return;
            }
            /* 开关关闭：保持原有 address 表单流程 */
            const prev = document.body.querySelector("m26-address-select");
            if (prev) prev.remove();
            const el = document.createElement("m26-address-select");
            el.dataset.prizeCode = btn.dataset.prizeCode;
            document.body.appendChild(el);
            document.addEventListener(
              "m26:address-saved",
              () => this._loadRecords(),
              { once: true },
            );
          });
        });
      }

      /* ── 多 SKU 开关开启时的中奖记录按钮 handler ──
       * 仅在 _skuEnabled=true 时被触发（_bindRecordActions 已按 data-record-action 分流）。
       * 与 autumn _renderRecordItem 对应按钮的功能对齐。 */
      _handleRecordOpenSku(button) {
        const prizeCode = button.dataset.prizeCode || "";
        /* 当前记录列表中的 item 可能不包含 productId / productHandle，
           sku-dialog 强制要求 prize.productId 存在——与中奖弹框同依赖。 */
        const item = this._recordsByCode && this._recordsByCode[prizeCode];
        if (!item) {
          if (m26ApiErrorTipLocal)
            m26ApiErrorTipLocal(new Error("Record item not found"));
          return;
        }
        /* 隐藏当前 record modal 的可见内容（保留 modal 内部状态：
           _isOpen=true、_bodyEl、按钮事件监听器、_bodyHtml 等），这样 SKU 弹框
           关闭后可直接 _restoreRecordModalAfterSku 恢复，且不会丢监听器 / 旧数据。
           _modal.close() 会真正销毁并清空 _bodyHtml，会造成"再次打开看到旧数据 / 空白"。
           遮罩（_overlayEl）保持显示，用户体验上仍然"处于 record modal 上下文"。 */
        this._hideRecordModalForSku();
        /* 派发 pd-sku:open 唤起多 SKU 弹框
         *
         * 与 M26RecordPanelLocal._handleRecordOpenSku / PdlotteryApp._openSkuDialog
         * 三处保持 prize / source / trigger 字段一致。 */
        document.dispatchEvent(
          new CustomEvent("pd-sku:open", {
            detail: {
              prize: {
                productId: item.claimProductId || item.productId || "",
                productHandle: item.productHandle || item.handle || "",
                name: item.prizeName || item.name || "",
                image: item.prizeImg || item.prizeUrl || item.image || "",
                activityUserPrizeCode:
                  item.activityUserPrizeCode || item.prizeCode || prizeCode,
                activityType: this._activityType || "",
                prizeType: 1,
                claimVariantId: item.claimVariantId || "",
                closeOnSuccess: true,
              },
              i18n: m26I18nLocal && m26I18nLocal.get("win"),
              source: "pdlottery-record",
              background: "transparent",
              trigger: button || null,
              disappeared:true
            },
          }),
        );
        /* 监听 pd-sku:close：SKU 弹框关闭（任意路径：× / 遮罩 / ESC / Confirm cancel）
           后恢复 record modal 显示——只取消视觉隐藏，不再重拉接口 / 重建 DOM。 */
        if (this._skuCloseHandler) {
          document.removeEventListener("pd-sku:close", this._skuCloseHandler);
        }
        this._skuCloseHandler = () => {
          /* 仅恢复 modal 显示，保留之前的数据与事件监听器，避免再次打开看到旧 / 空数据 */
          this._restoreRecordModalAfterSku();
          document.removeEventListener("pd-sku:close", this._skuCloseHandler);
          this._skuCloseHandler = null;
        };
        document.addEventListener("pd-sku:close", this._skuCloseHandler);
      }

      /* 把当前 record modal 的 box 视觉上隐藏（保留 _isOpen=true、_bodyEl、按钮监听器
         与 _bodyHtml），用于在 SKU 弹框打开期间让出可视区但不丢状态。
         遮罩（_overlayEl）保留显示，用户体验上仍处于 record modal 上下文。 */
      _hideRecordModalForSku() {
        if (!this._modal || !this._modal._boxEl) return;
        const box = this._modal._boxEl;
        box.classList.add("pdl-modal-hidden-by-sku");
        box.setAttribute("data-pdl-hidden-by-sku", "1");
        box.setAttribute("aria-hidden", "true");
      }

      /* SKU 弹框关闭后恢复 record modal。仅在确实处于被 SKU 隐藏状态时恢复，
         避免误操作恢复已被业务 close 的 modal。 */
      _restoreRecordModalAfterSku() {
        if (!this._modal || !this._modal._boxEl) return;
        const box = this._modal._boxEl;
        if (box.getAttribute("data-pdl-hidden-by-sku") !== "1") return;
        box.classList.remove("pdl-modal-hidden-by-sku");
        box.removeAttribute("data-pdl-hidden-by-sku");
        box.removeAttribute("aria-hidden");
      }

      _handleRecordClaim(button) {
        const prizeCode = button.dataset.prizeCode || "";
        button.disabled = true;
        button.classList.add("is-loading");
        button.setAttribute("aria-busy", "true");
        const item = this._recordsByCode && this._recordsByCode[prizeCode];
        /* 与 M26WinPopup._handleClaim 一致：GET 请求，参数放 URL：
           activityType + activityUserPrizeCode + (claimVariantId 可选)。
           不再 POST + body，与中奖弹框实物奖品领取传参完全对齐。 */
        let qs =
          "?activityType=" +
          encodeURIComponent(this._activityType || "") +
          "&activityUserPrizeCode=" +
          encodeURIComponent(prizeCode);
        if (item && item.claimVariantId) {
          qs +=
            "&claimVariantId=" +
            encodeURIComponent(String(item.claimVariantId));
        }
        const path = "/api/station/activity/raffle/queryClaimParams" + qs;
        this._lottery
          ._fetch(path)
          .then((res) => {
            const checkoutUrl =
              res &&
              (res.checkoutUrl ||
                res.url ||
                (res.data && res.data.checkoutUrl));
            if (checkoutUrl) {
              if (this._modal) this._modal.close();
              window.location.href = checkoutUrl;
            } else if (m26ApiErrorTipLocal) {
              m26ApiErrorTipLocal(res || new Error("No checkoutUrl"));
            }
          })
          .catch((err) => {
            if (m26ApiErrorTipLocal) m26ApiErrorTipLocal(err);
          })
          .finally(() => {
            button.classList.remove("is-loading");
            button.disabled = false;
            button.removeAttribute("aria-busy");
          });
      }

      /* 联系客服（autumn _handleRecordAction 中 action === "contact" 等价实现）
       *
       * 与 M26RecordPanelLocal._handleRecordContact 逻辑一致：
       *   1. 关闭 record modal（避免遮罩遮挡 Zendesk 弹框）
       *   2. 把 Zendesk launcher z-index 提到 1999（autumn magic 值）
       *   3. 优先调 window.zE("messenger", "open") 唤起 Zendesk
       *   4. Fallback：跳转 mailto 链接
       *
       * 当前 _renderRecordItem 没渲染 contact 按钮（PD 后端未返回 claimStatus 字段），
       * 但保留此方法以便未来后端字段补齐后可直接复用。 */
      _handleRecordContact(button) {
        if (this._modal) this._modal.close();
        try {
          const launcher = document.querySelector("#launcher");
          if (launcher) launcher.style.zIndex = "100000";
        } catch (_) {}
        if (typeof window.zE === "function") {
          try {
            window.zE("messenger", "open");
            return;
          } catch (_) {
            /* fall through to mailto fallback */
          }
        }
        const prizeCode =
          (button && button.dataset && button.dataset.prizeCode) || "";
        const href =
          (this._recordsByCode &&
            this._recordsByCode[prizeCode] &&
            this._recordsByCode[prizeCode].contactUrl) ||
          window.__MC_CONTACT_HREF__ ||
          "mailto:support@momcozy.com";
        try {
          window.open(href, "_blank", "noopener,noreferrer");
        } catch (_) {
          window.location.href = href;
        }
      }
    }

    customElements.define("pdlottery-record-modal", PdlotteryRecordModal);
  }

  /* ── PdlotteryApp 主自定义元素 ───────────────────────────────────────
   * 负责：
   *   1. 双视频状态机（idle → draw → result）
   *   2. Draw now 按钮绑定 → checkAndStart → 切换视频 → showWinPopup
   * ─────────────────────────────────────────────────────────────────── */
  if (!customElements.get("pdlottery-app")) {
    class PdlotteryApp extends HTMLElement {
      constructor() {
        super();
        this._lottery = null;
        this._drawing = false;
      }

      connectedCallback() {
        /* 解析 activityType */
        const sid = this.dataset.sectionId || "";
        this._activityType = resolveActivityType(sid);
        /* 覆盖全局 activityType，使 m26-mystery-box.js 共用常量生效 */
        if (this._activityType)
          window.__MC_ACTIVITY_TYPE__ = this._activityType;

        /* 多 SKU 选择弹框开关（默认 false）。
           开启时：
           a) startRaffleAuth / queryWinningRecord 接口透传 newRaffleFlow=true
           b) m26-win__btn 在 result>0 && prizeType=1 && needSelectVariant=true
              时唤起 pd-sku 多 SKU 弹框（替代原有的地址表单流程） */
        this._skuEnabled = this.dataset.enableSkuDialog === "true";

        this._lottery = new M26LotteryLocal({
          el: this,
          scrollTarget: this.querySelector(".pdlottery__video-stage"),
          activityType: this._activityType || "",
        });

        this._bindDraw();
        this._bindLoginGuard();
        this._bindChancesUpdate();
        this._bindSkuIntegration();
        /* 收集 prize block 配置的 prize_desc 兜底映射：
           键 = block.prize_name，值 = block.prize_desc
           当后端 startRaffleAuth 返回的 prizeInfo.prizeDesc 为空时，
           在 _showWinPopup 中按 prizeName 匹配此映射填充。 */
        this._collectPrizeDescFallback();
        this._initIdleVideo();
        this._checkHashScroll();
        this._schedulePrizeCardSync();
        this._onPrizeResize = () => this._schedulePrizeCardSync();
        window.addEventListener("resize", this._onPrizeResize);
        if ("ResizeObserver" in window && !this._prizeRO) {
          this._prizeRO = new ResizeObserver(() =>
            this._schedulePrizeCardSync(),
          );
          this._prizeRO.observe(this);
        }
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => {
            if (this.isConnected) this._schedulePrizeCardSync();
          });
        }
      }

      disconnectedCallback() {
        this._unbindSkuIntegration();
        if (this._lottery) {
          this._lottery.destroy();
          this._lottery = null;
        }
        if (this._onLoginGuard) {
          this.removeEventListener("click", this._onLoginGuard, true);
          this._onLoginGuard = null;
        }
        if (this._onRetry) {
          document.removeEventListener("m26:retry", this._onRetry);
          this._onRetry = null;
        }
        if (this._onPrizeResize) {
          window.removeEventListener("resize", this._onPrizeResize);
          this._onPrizeResize = null;
        }
        if (this._prizeRO) {
          this._prizeRO.disconnect();
          this._prizeRO = null;
        }
        clearTimeout(this._prizeCardSyncTimer2);
        cancelAnimationFrame(this._prizeCardSyncTimer);
        this._mqlMobile = null;
      }

      _schedulePrizeCardSync() {
        cancelAnimationFrame(this._prizeCardSyncTimer);
        clearTimeout(this._prizeCardSyncTimer2);
        /* 优先走 rAF，保证在下一帧布局稳定后执行 */
        this._prizeCardSyncTimer = requestAnimationFrame(() => {
          this._syncPrizeCardHeights();
          /* 字体/图片可能在 rAF 后才加载完，300ms 兜底再跑一次 */
          this._prizeCardSyncTimer2 = setTimeout(() => {
            this._syncPrizeCardHeights();
          }, 300);
        });
      }

      _syncPrizeCardHeights() {
        const cards = [...this.querySelectorAll(".pdlottery__prize-card")];
        if (!cards.length) return;

        const ensureWrap = (card) => {
          let wrap = card.querySelector(".pdlottery__prize-img-wrap");
          if (wrap) return wrap;
          wrap = document.createElement("div");
          wrap.className = "pdlottery__prize-img-wrap";
          const name = card.querySelector(".pdlottery__prize-name");
          if (name && name.parentNode === card) card.insertBefore(wrap, name);
          else card.insertBefore(wrap, card.firstChild);
          return wrap;
        };

        /* 缓存 matchMedia 实例，避免每次重建 */
        if (!this._mqlMobile)
          this._mqlMobile = window.matchMedia("(max-width: 768px)");
        const ratio = this._mqlMobile.matches ? 7 / 8 : 132 / 150;

        /* 预先缓存每张 card 对应的 wrap 和 name，避免后续重复 querySelector */
        const cardMeta = cards.map((card) => ({
          card,
          wrap: ensureWrap(card),
          name: card.querySelector(".pdlottery__prize-name"),
        }));

        /* ── 写：先整批清空高度，一次性触发回流 ── */
        cardMeta.forEach(({ card, wrap, name }) => {
          card.style.height = "";
          wrap.style.height = "";
          if (name) name.style.height = "";
        });

        /* ── 读：批量读取 wrap 宽度 ── */
        let maxWrapW = 0;
        cardMeta.forEach(({ wrap }) => {
          const w = Math.ceil(wrap.getBoundingClientRect().width || 0);
          if (w > maxWrapW) maxWrapW = w;
        });

        const wrapH = maxWrapW ? Math.round(maxWrapW * ratio) : 0;

        /* ── 写：批量写入 wrap 高度 ── */
        cardMeta.forEach(({ wrap }) => {
          if (wrapH) wrap.style.height = `${wrapH}px`;
          const img = wrap.querySelector("img");
          if (img && !img.complete) {
            img.addEventListener("load", () => this._schedulePrizeCardSync(), {
              once: true,
            });
          }
        });

        /* ── 读：批量读取 name 高度 ── */
        let maxNameH = 0;
        cardMeta.forEach(({ name }) => {
          if (name) {
            const h = Math.ceil(name.getBoundingClientRect().height || 0);
            if (h > maxNameH) maxNameH = h;
          }
        });

        /* ── 写：批量写入 name 高度 ── */
        if (maxNameH) {
          cardMeta.forEach(({ name }) => {
            if (name) name.style.height = `${maxNameH}px`;
          });
        }

        /* ── 读：批量读取 card 总高（已稳定后读一次）── */
        let maxCardH = 0;
        cardMeta.forEach(({ card, wrap, name }) => {
          const cs = window.getComputedStyle(card);
          const gap = parseFloat(cs.rowGap || cs.gap) || 0;
          const h =
            Math.ceil(wrap.getBoundingClientRect().height || wrapH || 0) +
            gap +
            (name ? maxNameH : 0);
          if (h > maxCardH) maxCardH = h;
        });

        /* ── 写：批量写入 card 高度 ── */
        if (maxCardH) {
          cardMeta.forEach(({ card }) => {
            card.style.height = `${maxCardH}px`;
          });
        }
      }

      /* ── 待机视频：确保自动播放 ── */
      _initIdleVideo() {
        const idle = this.querySelector(".pdlottery__video--idle");
        if (!idle) return;
        idle.muted = true;
        idle.loop = true;

        const playIdle = () => {
          idle.play().catch(() => {
            const onInteract = () => {
              idle.play().catch(() => {});
              document.removeEventListener("click", onInteract);
            };
            document.addEventListener("click", onInteract, { once: true });
          });
        };

        if (idle.readyState >= 1) {
          playIdle();
        } else {
          idle.addEventListener("loadedmetadata", playIdle, { once: true });
        }
      }

      /* ── 登录成功后刷新页面，滚动到本组件可视区 ── */
      _checkHashScroll() {
        const sid = this.dataset.sectionId || "";
        const expectedHash = "pdlottery-" + sid;
        /* location.hash 包含 # 前缀，去掉后比对 */
        const hash = window.location.hash.slice(1);
        if (hash !== expectedHash) return;
        /* 清除 hash，避免刷新后重复滚动（不产生历史记录） */
        history.replaceState(
          null,
          "",
          window.location.pathname + window.location.search,
        );
        /* 等待页面布局稳定（图片/视频等资源加载可能改变高度），
           用 300ms 延迟确保滚动位置准确 */
        setTimeout(() => {
          this._scrollToShowDrawBtn();
        }, 300);
      }

      /* ── 滚动使视频区与 Draw now 按钮同时可见 ──
       * 策略：
       *   1. 计算 sticky header 高度作为顶部安全偏移
       *   2. 以 pdlottery__actions（按钮区）底部为下锚点，
       *      确保 Draw now 按钮完整进入视口
       *   3. 同时保证 section 顶部不被 header 遮挡
       *   取 topA 与 topB 的较大值：
       *     - topB ≤ topA：视口足够高，用 topA（section 顶部对齐）即可
       *     - topB > topA：视口较矮，需多向下滚以露出按钮，用 topB
       */
      _scrollToShowDrawBtn() {
        /* 获取 sticky header 总高度 */
        const stickyEls = document.querySelectorAll(
          ".m26-nav.is-sticky, .m26-nav.is-fixed-top, [data-header-sticky]",
        );
        let headerH = 0;
        stickyEls.forEach((s) => {
          headerH += s.getBoundingClientRect().height;
        });

        const section = this.closest(".pdlottery-section") || this;
        const actionsEl = this.querySelector(".pdlottery__actions");

        /* 方案A：section 顶部滚到 header 下方 20px */
        const topA =
          section.getBoundingClientRect().top + window.scrollY - headerH - 20;

        /* 方案B：让 Draw now 按钮区底部滚入视口底部 20px 以上 */
        let topB = topA; /* 若找不到按钮区则降级为方案A */
        if (actionsEl) {
          const actionsBottom =
            actionsEl.getBoundingClientRect().bottom + window.scrollY;
          topB = actionsBottom - window.innerHeight + 20;
        }

        const scrollTop = Math.max(0, Math.max(topA, topB));

        const reduceMotion =
          window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        window.scrollTo({
          top: scrollTop,
          behavior: reduceMotion ? "auto" : "smooth",
        });
      }

      /* ── 本组件专用登录唤起，redirect 带 hash 标记 ── */
      _pdlLogin() {
        const loginDialog = document.querySelector("login-dialog");
        if (!loginDialog || typeof loginDialog.open !== "function") {
          /* 降级：走通用登录 */
          if (m26LoginLocal) m26LoginLocal();
          return;
        }
        /* iOS Safari 跳顶修复：MO 监听 body.q-body--prevent-scroll class 移除 */
        const savedScrollY = window.scrollY || 0;
        const savedActiveEl = document.activeElement;

        let restored = false;
        let timeoutId = null;
        const cleanup = () => {
          if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
          }
          observer.disconnect();
        };
        const restore = () => {
          if (restored) return;
          restored = true;
          cleanup();
          if (savedScrollY > 0) window.scrollTo(0, savedScrollY);
          try {
            if (
              savedActiveEl &&
              savedActiveEl !== document.body &&
              savedActiveEl !== document.documentElement &&
              typeof savedActiveEl.focus === "function"
            ) {
              savedActiveEl.focus({ preventScroll: true });
            }
          } catch (_) { /* element 已被移除，静默忽略 */ }
        };
        /* rAF 等 commit 后再 getComputedStyle，避免读到旧样式 */
        const observer = new MutationObserver(() => {
          if (document.body.classList.contains("q-body--prevent-scroll")) return;
          requestAnimationFrame(() => {
            const csHtml = window.getComputedStyle(document.documentElement);
            if (
              !csHtml.overflow.includes("hidden") &&
              !csHtml.overflowY.includes("hidden")
            ) {
              restore();
            }
          });
        });
        observer.observe(document.body, {
          attributes: true,
          attributeFilter: ["class"],
        });
        timeoutId = setTimeout(cleanup, 60000);

        const sid = this.dataset.sectionId || "";
        const url = new URL(window.location.href);
        url.hash = "pdlottery-" + sid;
        /* 优先使用 section 配置的 register_source（参考 autumn 模式：register_source
           与 activityType 解耦，便于登录/注册来源独立埋点），未配置时回退到
           `activity_<activityType>` 以兼容旧行为。 */
        const registerSource =
          this.dataset.registerSource ||
          `activity_${this._activityType || window.__MC_ACTIVITY_TYPE__ || ""}`;
        loginDialog.open(null, {
          activityType: registerSource,
          mustAgreeEmail: true,
          redirect: url.toString(),
        });
      }

      /* ── 统一登录拦截（捕获阶段，比 m26-login-guard 更高层） ── */
      _bindLoginGuard() {
        /* 在 pdlottery-app 上用捕获阶段拦截所有需要登录的按钮点击。
           pdlottery-app 是 m26-login-guard 的祖先，捕获阶段比
           m26-login-guard 更早执行，未登录时 stopPropagation 可阻止
           m26-login-guard 再次触发，防止双弹框。 */
        this._onLoginGuard = (e) => {
          /* modal overlay 内的点击不拦截（分享弹框内点击分享项） */
          if (e.target.closest(".m26-modal-overlay")) return;
          const isDraw = !!e.target.closest("[data-pdlottery-draw]");
          const isShare = !!e.target.closest("m26-share-panel");
          const isRecord = !!e.target.closest("m26-record-panel");
          if (!isDraw && !isShare && !isRecord) return;
          pdSyncM26AuthFromCookie();
          const auth = pdGetM26Auth();
          if (!auth || !auth.user) {
            e.stopPropagation();
            e.preventDefault();
            this._pdlLogin();
          }
        };
        this.addEventListener("click", this._onLoginGuard, true);
      }

      /* ── Draw now 按钮 ── */
      _bindDraw() {
        const btn = this.querySelector("[data-pdlottery-draw]");
        if (btn) {
          btn.addEventListener("click", () => {
            this._handleDraw();
          });
        }

        this._onRetry = () => {
          this._lottery && this._lottery.refreshChances();
        };
        document.addEventListener("m26:retry", this._onRetry);
      }

      /* ── 监听抽奖次数更新，同步到 head-right span ── */
      _bindChancesUpdate() {
        this._chanceSpan = this.querySelector(".pdlottery__head-right span");
        this.addEventListener("m26:chances-updated", (e) => {
          this._updateChanceDisplay(e.detail.chances);
        });
        /* 与 m26-mystery-box.js 的 M26Lottery 构造函数中 onLogin 回调一致：
           已登录则立即拉取，未登录则等 onLogin 回调触发后自动拉取 */
        this._lottery.refreshChances().catch(() => {});
      }

      _updateChanceDisplay(count) {
        if (!this._chanceSpan) return;
        const isPlural = count > 1;
        this._chanceSpan.textContent = count;
        this._chanceSpan.setAttribute(
          "aria-label",
          count + (isPlural ? " chances" : " chance"),
        );
        const label = this.querySelector(".pdlottery__chance-label");
        if (label) label.textContent = isPlural ? "Chances" : "Chance";
      }

      async _handleDraw() {
        if (this._drawing) return;
        this._drawing = true;
        const btn = this.querySelector("[data-pdlottery-draw]");
        if (btn) {
          btn.disabled = true;
          btn.setAttribute("aria-busy", "true");
        }
        try {
          pdSyncM26AuthFromCookie();
          const auth = pdGetM26Auth();
          if (!auth || !auth.user) {
            this._pdlLogin();
            return;
          }

          await this._lottery._fetch(
            "/api/station/activity/raffle/checkStatus",
            {
              method: "POST",
              body: JSON.stringify({ activityType: this._activityType || "" }),
            },
          );

          const chances = await this._lottery.refreshChances();
          if (chances < 1) {
            this._showWinPopup({ prizeType: -1 });
            return;
          }

          /* 点击按钮后立即发起抽奖请求，与视频播放并行；
             视频播完后直接 await 结果，已返回则立即展示，未返回则等待。
             多 SKU 开关开启时在 query string 上追加 newRaffleFlow=true（与 autumn 一致）。 */
          const rafflePromise = this._startRaffleWithSku();
          await this._playDrawVideo();
          const result = await rafflePromise;
          if (!result || result.noChances) {
            this._showWinPopup({ prizeType: -1 });
            return;
          }
          this._showWinPopup(result);
        } catch (err) {
          console.dir(err);
          if (err && err.code === "10001003") {
            this._pdlLogin();
          } else {
            m26ApiErrorTipLocal(err);
          }
        } finally {
          this._drawing = false;
          if (btn) {
            btn.disabled = false;
            btn.removeAttribute("aria-busy");
          }
        }
      }

      /* 透传 newRaffleFlow 的抽奖接口包装（开关关闭时与原 _startRaffle 等价） */
      _startRaffleWithSku() {
        const endpoint = this._skuEnabled
          ? "/api/station/activity/raffle/startShopRaffleAuth"
          : "/api/station/activity/raffle/startRaffleAuth";
        const path =
          `${endpoint}?activityType=` +
          encodeURIComponent(this._activityType || "") +
          (this._skuEnabled ? "&newRaffleFlow=true" : "");
        return this._lottery._fetch(path).then((res) => {
          this._lottery.refreshChances();
          if (res && res.result === -1 && res.msg === "0")
            return { noChances: true };
          if (res && res.result < 0) throw res;
          return res;
        });
      }

      /* ── 视频状态切换 ── */
      _playDrawVideo() {
        const idle = this.querySelector(".pdlottery__video--idle");
        const draw = this.querySelector(".pdlottery__video--draw");
        const stage = this.querySelector("[data-pdlottery-stage]");

        /* 若没有配置抽奖视频，立即 resolve */
        if (!draw) return Promise.resolve();
        if (draw.preload !== "auto") draw.preload = "auto";

        if (stage) stage.classList.remove("is-draw");

        if (idle) {
          idle.play().catch(() => {});
        }

        try {
          draw.pause();
          draw.currentTime = 0;
        } catch (_) {}

        const waitFirstFrame = () =>
          new Promise((r) => {
            let done = false;
            const ok = () => {
              if (done) return;
              done = true;
              r();
            };
            const t = setTimeout(ok, 1200);
            if (typeof draw.requestVideoFrameCallback === "function") {
              draw.requestVideoFrameCallback(() => {
                clearTimeout(t);
                ok();
              });
              return;
            }
            const onData = () => {
              draw.removeEventListener("loadeddata", onData);
              clearTimeout(t);
              ok();
            };
            draw.addEventListener("loadeddata", onData);
          });

        return new Promise((resolve) => {
          const fadeMs = 300;
          const onEnded = () => {
            draw.removeEventListener("ended", onEnded);
            if (stage) stage.classList.remove("is-draw");
            setTimeout(() => {
              try {
                draw.pause();
              } catch (_) {}
              resolve();
            }, fadeMs);
          };
          draw.addEventListener("ended", onEnded);

          draw
            .play()
            .then(() => {
              waitFirstFrame().then(() => {
                if (stage) stage.classList.add("is-draw");
              });
            })
            .catch(() => {
              draw.removeEventListener("ended", onEnded);
              resolve();
            });
        });
      }

      /* ── 展示获奖弹窗 ── */
      _showWinPopup(prizeInfo) {
        if (!this._winPopup) {
          this._winPopup = document.createElement("m26-win-popup");
          document.body.appendChild(this._winPopup);
        }
        /* prize_desc 兜底：后端返回 prizeInfo.prizeDesc 为空时，按 prizeName
           匹配 block 配置的 prize_desc。优先级：后端 > block > 空字符串。 */
        const enrichedPrizeInfo = this._enrichPrizeInfoWithDesc(prizeInfo);
        /* coupon_tip_override 注入：仅 prizeType=3 使用，覆盖 i.tips_prefix_html。
           数据源：pdlottery-app 的 data-coupon-tip-override 属性。 */
        const couponTipOverride = this.dataset.couponTipOverride || "";
        const wrapped = this._maybeWrapForSku(enrichedPrizeInfo);
        if (
          couponTipOverride &&
          wrapped &&
          Number(wrapped.prizeType) === 3
        ) {
          wrapped._couponTipOverride = couponTipOverride;
        }
        this._winPopup.show({
          prizeInfo: wrapped,
          anchor: this.querySelector(".pdlottery__video-stage"),
        });
        const bg = pdGetSelectedCodeBg(this);
        requestAnimationFrame(() => {
          const box = document.querySelector(
            ".m26-modal-box.m26-win-popup__modal.is-open",
          );
          pdSetSelectedCodeBgVars(box, bg.pc, bg.mobile);
          pdEnhanceDialogA11y(box);
        });
      }

      /* ── 多 SKU 弹框集成（仅在 section 开关开启时启用） ── */
      /* ──────────────────────────────────────────────────── */

      /* 收集 prize card DOM 上的 data-prize-level / data-prize-desc，构造成 { level: desc } 字典。
         匹配键：prize_level（block 配置）；后端 prizeInfo.result >= 0 时按此匹配。
         注意：不能用 prizeName 做匹配键——前端配置的 prizeName 是运营展示文案，
         后端 prizeInfo.prizeName 可能是翻译/带规格的版本，两者不一致。 */
      _collectPrizeDescFallback() {
        const map = {};
        const cards = this.querySelectorAll(".pdlottery__prize-card");
        cards.forEach((card) => {
          const rawLevel = card.dataset.prizeLevel;
          if (rawLevel === undefined || rawLevel === "") return;
          const level = Number(rawLevel);
          if (!Number.isFinite(level) || level < 0) return;
          /* 多卡片同 level 时，保留第一个非空 desc，避免覆盖。 */
          const desc = card.dataset.prizeDesc || "";
          if (!(level in map) || (desc && !map[level])) map[level] = desc;
        });
        this._prizeDescByLevel = map;
      }

      /* 用 block 配置的 prize_desc 兜底 prizeInfo.prizeDesc：
         - 后端已返回非空 prizeDesc → 不动，沿用后端
         - 后端 prizeDesc 为空 → 按 prizeInfo.result（>=0）匹配 block.desc
         - 仍未匹配到 → 从翻译 win.default_prize_desc 兜底
         - 都没有 → 保持空字符串 */
      _enrichPrizeInfoWithDesc(prizeInfo) {
        if (!prizeInfo || typeof prizeInfo !== "object") return prizeInfo;
        const fromBackend = (prizeInfo.prizeDesc || "").trim();
        if (fromBackend) return prizeInfo;
        const result = Number(prizeInfo.result);
        if (!Number.isFinite(result) || result < 0) return prizeInfo;
        let fromBlock =
          this._prizeDescByLevel && this._prizeDescByLevel[result]
            ? this._prizeDescByLevel[result]
            : "";
        if (!fromBlock) {
          /* 仍未匹配到 block 配置的 desc，从翻译文件兜底 */
          const winI18n =
            (m26I18nLocal &&
              typeof m26I18nLocal.get === "function" &&
              m26I18nLocal.get("win")) ||
            null;
          fromBlock = (winI18n && winI18n.default_prize_desc) || "";
          console.log(winI18n, "default_prize_desc");
        }
        if (!fromBlock) return prizeInfo;
        return Object.assign({}, prizeInfo, { prizeDesc: fromBlock });
      }

      /* 判断 prizeInfo 是否需要走"多 SKU 选择"流程（result>0 && prizeType=1 && needSelectVariant=true）。
         开关关闭 / 不满足条件时返回原对象。返回 { ...prizeInfo, _skuOpenable: true } 用于让
         m26-win-popup 渲染时把按钮 action 切到 'open-sku'。 */
      _maybeWrapForSku(prizeInfo) {
        if (!this._skuEnabled) return prizeInfo;
        if (!prizeInfo || typeof prizeInfo !== "object") return prizeInfo;
        const result = Number(prizeInfo.result);
        const ptype = Number(prizeInfo.prizeType);
        const enriched = { ...prizeInfo, _skuEnabled: true };
        if (
          Number.isFinite(result) &&
          result > 0 &&
          ptype === 1 &&
          prizeInfo.needSelectVariant === true
        ) {
          enriched._skuOpenable = true;
        }
        return enriched;
      }

      _bindSkuIntegration() {
        if (!this._skuEnabled) return;
        this._onWinOpenSku = (e) => {
          this._openSkuDialog(
            e && e.detail && e.detail.prizeInfo,
            e && e.target,
          );
        };
        this._onSkuClaimed = (e) => {
          this._handleSkuClaimed(e && e.detail);
        };
        this._onSkuClose = () => {
          this._restoreWinPopup();
        };
        document.addEventListener("m26-win:open-sku", this._onWinOpenSku);
        document.addEventListener("pd-sku:claimed", this._onSkuClaimed);
        document.addEventListener("pd-sku:close", this._onSkuClose);
      }

      _unbindSkuIntegration() {
        if (this._onWinOpenSku) {
          document.removeEventListener("m26-win:open-sku", this._onWinOpenSku);
          this._onWinOpenSku = null;
        }
        if (this._onSkuClaimed) {
          document.removeEventListener("pd-sku:claimed", this._onSkuClaimed);
          this._onSkuClaimed = null;
        }
        if (this._onSkuClose) {
          document.removeEventListener("pd-sku:close", this._onSkuClose);
          this._onSkuClose = null;
        }
      }

      /* 唤起 pd-sku 多 SKU 弹框：先隐藏 m26-win-popup（保留 modal state 以便恢复），
         再派发 pd-sku:open 事件给 lottery-common-sku 组件。
         prize / source / trigger / background 字段与 M26RecordPanelLocal._handleRecordOpenSku
         / PdlotteryRecordModal._handleRecordOpenSku 保持一致。 */
      _openSkuDialog(prizeInfo, trigger) {
        if (!prizeInfo) return;
        this._hideWinPopupForSku();
        document.dispatchEvent(
          new CustomEvent("pd-sku:open", {
            detail: {
              prize: {
                productId:
                  prizeInfo.claimProductId || prizeInfo.productId || "",
                productHandle:
                  prizeInfo.productHandle || prizeInfo.handle || "",
                name: prizeInfo.prizeName || prizeInfo.name || "",
                image:
                  prizeInfo.prizeImg ||
                  prizeInfo.prizeUrl ||
                  prizeInfo.image ||
                  "",
                activityUserPrizeCode:
                  prizeInfo.activityUserPrizeCode || prizeInfo.prizeCode || "",
                activityType: this._activityType || "",
                prizeType: prizeInfo.prizeType,
                claimVariantId: prizeInfo.claimVariantId || "",
                closeOnSuccess: prizeInfo.prizeType !== 1,
                raw: prizeInfo,
              },
              trigger: trigger || null,
              source: "pd-variant-action",
              background: "transparent",
              i18n: (m26I18nLocal && m26I18nLocal.get("win")) || {
                /* lottery-i18n 解析失败时的兜底（保留之前 PdlotteryApp 实现的硬编码文案） */
                title: "Select Your Prize",
                cancel: "Cancel",
                confirm: "Confirm",
                load_error: "Failed to load product info",
                claim_success: "Prize claimed",
              },
              disappeared:true
            },
          }),
        );
      }

      /* 把 m26-win-popup 的 modal box 视觉上隐藏（保留 modal._isOpen=true 与内部 slot 内容），
         这样 SKU 弹框关闭后可直接恢复，不用重新 _render 与重连按钮监听 */
      _hideWinPopupForSku() {
        if (!this._winPopup || !this._winPopup._modal) return;
        const modal = this._winPopup._modal;
        const box = modal._boxEl;
        const overlay = modal._overlayEl;
        if (box) {
          box.classList.add("pdl-modal-hidden-by-sku");
          box.setAttribute("data-pdl-hidden-by-sku", "1");
          box.setAttribute("aria-hidden", "true");
        }
        /* 遮罩继续接受点击（可作为打开 SKU 弹框时的"已遮罩"感受），
           也可通过 overlay.classList.add('pdl-modal-hidden-by-sku') 隐藏 */
      }

      /* SKU 弹框关闭后恢复 m26-win-popup */
      _restoreWinPopup() {
        if (!this._winPopup || !this._winPopup._modal) return;
        const modal = this._winPopup._modal;
        const box = modal._boxEl;
        if (!box) return;
        // 只在确实处于被 SKU 隐藏状态时恢复（避免误操作恢复已被业务 close 的 modal）
        if (!box.classList.contains("pdl-modal-hidden-by-sku")) return;
        box.classList.remove("pdl-modal-hidden-by-sku");
        box.removeAttribute("data-pdl-hidden-by-sku");
        box.removeAttribute("aria-hidden");
      }

      /* 处理 pd-sku:claimed：
         - resultType='redirect' → 实物奖品，跳转 checkoutUrl 前先关闭所有弹框，
           避免回退按钮命中 bfcache 时页面还显示弹框
         - resultType='success'   → 非实物奖品，关闭 m26-win + 弹成功 toast */
      _handleSkuClaimed(detail) {
        if (!detail) return;
        if (detail.resultType === "redirect" && detail.checkoutUrl) {
          /* 关闭本组件关联的所有弹框：m26-win / 两个 record modal。
             sku 弹框由其组件内部在 claimed 后自动 close，无需这里介入。 */
          if (this._winPopup && this._winPopup._modal) {
            this._winPopup._modal.close();
          }
          const recordModal = this.querySelector("m26-record-modal")
            ? this.querySelector("m26-record-modal")._modal
            : null;
          if (recordModal) recordModal.close();
          if (this._recordModal) this._recordModal.close();
          /* 跳转 checkoutUrl */
          //window.location.href = detail.checkoutUrl;
          return;
        }
        if (this._winPopup && this._winPopup._modal) {
          this._winPopup._modal.close();
        }
      }
    }

    customElements.define("pdlottery-app", PdlotteryApp);
  }

  /* ── 暴露 m26 基础设施到 window，供 m26-record-modal 共享组件调用 ──
     PD 自身 IIFE 内的局部变量不挂在 window 上，但 <m26-record-modal> 是独立
     加载的脚本，必须通过 window 才能拿到这些工具。 */
  window.M26ModalLocal = M26ModalLocal;
  window.m26AuthLocal = m26AuthLocal;
  window.m26FetchLocal = m26FetchLocal;
  window.m26ToastLocal = m26ToastLocal;
  window.m26ApiErrorTipLocal = m26ApiErrorTipLocal;
  window.m26LoginLocal = m26LoginLocal;
  window.m26I18nLocal = m26I18nLocal;
  /* 暴露 pdLoginForEl，让共享 m26-record-modal 在未登录时能复用本组件
     带 hash 的登录唤起（确保登录后回跳可触发 _checkHashScroll 滚动）。
     注意：本函数依赖 IIFE 内部的 m26LoginLocal 与 PdlotteryApp._pdlLogin，
     必须挂在 IIFE 末尾，函数定义（1958 行）已声明 hoisting 兼容。 */
  window.pdLoginForEl = pdLoginForEl;
})();
